// // // import React, { useState, useEffect, useCallback, useMemo } from "react";
// // // import {
// // //   Dialog,
// // //   DialogTitle,
// // //   DialogContent,
// // //   DialogActions,
// // //   Button,
// // //   FormControl,
// // //   InputLabel,
// // //   Select,
// // //   MenuItem,
// // //   Box,
// // //   Typography,
// // //   Checkbox,
// // //   FormControlLabel,
// // //   List,
// // //   ListItem,
// // //   ListItemIcon,
// // //   ListItemText,
// // //   IconButton,
// // //   Alert,
// // //   Divider,
// // //   CircularProgress,
// // // } from "@mui/material";
// // // import {
// // //   Close as CloseIcon,
// // //   ExpandLess as ExpandLessIcon,
// // //   ExpandMore as ExpandMoreIcon,
// // // } from "@mui/icons-material";
// // // import {
// // //   getUserPermissionsByUserId,
// // //   updateUserPermissions,
// // //   fetchActiveStudies,
// // // } from "../utils/api";

// // // const maroon = "#500000";

// // // const EditUserPermissionsModal = ({ open, onClose, onSave, user }) => {
// // //   const [selectedRole, setSelectedRole] = useState("");
// // //   const [permissions, setPermissions] = useState({});
// // //   const [loading, setLoading] = useState(false);
// // //   const [error, setError] = useState(null);
// // //   const [userPermissions, setUserPermissions] = useState([]);
// // //   const [studies, setStudies] = useState([]);
// // //   const [studiesLoading, setStudiesLoading] = useState(false);
// // //   const [selectedStudies, setSelectedStudies] = useState([]);
// // //   const [expandedSections, setExpandedSections] = useState({
// // //     admin: true,
// // //     biobank: true,
// // //     researcher: true,
// // //   });

// // //   const roleOptions = [
// // //     "Super Admin",
// // //     "System Manager",
// // //     "BioBank Coordinator",
// // //     "Clinic Coordinator",
// // //     "Sample Technician",
// // //     "Regulatory Admin",
// // //     "Viewer",
// // //   ];

// // //   const roleDescriptions = {
// // //     "Super Admin":
// // //       "Full system authority. This includes unrestricted access to every functions in the Admin, BioBank and Researcher modules.",
// // //     "System Manager":
// // //       "Responsible for platform setup and governance. Can configure users, manage data visibility, and oversee auditing activities, but cannot enact any regulatory concerns.",
// // //     "BioBank Coordinator":
// // //       "Oversees BioBank operational activities. Manages kits, scheduling, and supervision sample logistics, but does not handle patient health records or regulatory actions.",
// // //     "Clinic Coordinator":
// // //       "Handles day-to-day workflows, focused on patient scheduling, intake, and collection of samples during visits.",
// // //     "Sample Technician":
// // //       "Focused solely on laboratory workflows. Processes collected samples into aliquots and manages check-ins/out for shipments.",
// // //     "Regulatory Admin":
// // //       "Read-only access for compliance and regulatory oversight. Provides oversight of consent, patient traceability, and sample lifecycle data.",
// // //     Viewer:
// // //       "Read-only access for operational oversight. Provides visibility into patient scheduling, patient flow, and sample collection, without rights to enact changes or visibility.",
// // //   };

// // //   const permissionStructure = {
// // //     admin: {
// // //       label: "Admin",
// // //       permissions: [
// // //         "Task Management",
// // //         "User Management",
// // //         "Sample Data",
// // //         "Participant Data",
// // //         "Program Directory",
// // //       ],
// // //     },
// // //     biobank: {
// // //       label: "BioBank",
// // //       permissions: [
// // //         "Participant Scheduling",
// // //         "Collection Kits",
// // //         "Participant Check-in",
// // //         "Sample Collection",
// // //         "Sample Processing",
// // //         "Aliquot Management",
// // //       ],
// // //     },
// // //     researcher: {
// // //       label: "Researcher",
// // //       permissions: ["Data Access", "Data Export"],
// // //     },
// // //   };

// // //   // Predefined role permissions
// // //   const rolePermissions = useMemo(
// // //     () => ({
// // //       "Super Admin": {
// // //         admin: true,
// // //         biobank: true,
// // //         researcher: true,
// // //       },
// // //       "System Manager": {
// // //         admin: true,
// // //         biobank: true,
// // //         researcher: false,
// // //       },
// // //       "BioBank Coordinator": {
// // //         admin: false,
// // //         biobank: true,
// // //         researcher: false,
// // //       },
// // //       "Clinic Coordinator": {
// // //         admin: false,
// // //         biobank: true,
// // //         researcher: false,
// // //       },
// // //       "Sample Technician": {
// // //         admin: false,
// // //         biobank: true,
// // //         researcher: false,
// // //       },
// // //       "Regulatory Admin": {
// // //         admin: true,
// // //         biobank: false,
// // //         researcher: false,
// // //       },
// // //       Viewer: {
// // //         admin: true,
// // //         biobank: true,
// // //         researcher: false,
// // //       },
// // //     }),
// // //     []
// // //   );

// // //   const loadUserPermissions = useCallback(async () => {
// // //     if (!user?.userId) return;

// // //     try {
// // //       setLoading(true);
// // //       const permissions = await getUserPermissionsByUserId(user.userId);
// // //       setUserPermissions(permissions);

// // //       const existingStudyPermissions = (permissions || [])
// // //         .filter((permission) => permission.module?.toLowerCase() === "study")
// // //         .map((permission) => permission.permission);
// // //       setSelectedStudies(existingStudyPermissions);

// // //       // Initialize permissions based on user's current role
// // //       const userRole =
// // //         Array.isArray(user.userRoles) && user.userRoles.length > 0
// // //           ? user.userRoles[0]
// // //           : user.userRole || "";
// // //       const currentPermissions = rolePermissions[userRole] || {};
// // //       setPermissions(currentPermissions);

// // //       // If user has existing permissions, load them
// // //       if (permissions && permissions.length > 0) {
// // //         const existingPermissions = {};

// // //         permissions.forEach((permission) => {
// // //           if (permission.module) {
// // //             existingPermissions[permission.module.toLowerCase()] = true;
// // //           }
// // //         });

// // //         setPermissions(existingPermissions);
// // //       }
// // //     } catch (err) {
// // //       console.error("Error loading user permissions:", err);
// // //       setError("Failed to load user permissions");
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   }, [user?.userId, user?.userRole, user?.userRoles, rolePermissions]);

// // //   useEffect(() => {
// // //     const loadStudies = async () => {
// // //       try {
// // //         setStudiesLoading(true);
// // //         const activeStudies = await fetchActiveStudies();
// // //         setStudies(activeStudies);
// // //       } catch (err) {
// // //         console.error("Error loading studies:", err);
// // //         setStudies([]);
// // //       } finally {
// // //         setStudiesLoading(false);
// // //       }
// // //     };

// // //     if (open) {
// // //       loadStudies();
// // //     }
// // //   }, [open]);

// // //   useEffect(() => {
// // //     if (open && user) {
// // //       // Handle both single userRole and array userRoles
// // //       const userRole =
// // //         Array.isArray(user.userRoles) && user.userRoles.length > 0
// // //           ? user.userRoles[0]
// // //           : user.userRole || "";
// // //       setSelectedRole(userRole);
// // //       setError(null);
// // //       loadUserPermissions();
// // //     }
// // //   }, [open, user, loadUserPermissions]);

// // //   const handleRoleChange = (event) => {
// // //     const role = event.target.value;
// // //     setSelectedRole(role);

// // //     // Update permissions based on selected role
// // //     const rolePerms = rolePermissions[role] || {};
// // //     setPermissions(rolePerms);
// // //   };

// // //   const handlePermissionChange = (section, checked) => {
// // //     // Roles are predefined — only section-level changes are allowed.
// // //     setPermissions((prev) => ({
// // //       ...prev,
// // //       [section]: checked,
// // //     }));
// // //   };

// // //   const handleStudyToggle = (irbStudy) => {
// // //     setSelectedStudies((prev) =>
// // //       prev.includes(irbStudy)
// // //         ? prev.filter((s) => s !== irbStudy)
// // //         : [...prev, irbStudy]
// // //     );
// // //   };

// // //   const handleAllStudiesToggle = (checked) => {
// // //     if (checked) {
// // //       setSelectedStudies(studies.map((study) => study.irbStudy));
// // //     } else {
// // //       setSelectedStudies([]);
// // //     }
// // //   };

// // //   const allStudiesSelected =
// // //     studies.length > 0 && selectedStudies.length === studies.length;

// // //   const toggleSection = (section) => {
// // //     setExpandedSections((prev) => ({
// // //       ...prev,
// // //       [section]: !prev[section],
// // //     }));
// // //   };

// // //   const handleSave = async () => {
// // //     try {
// // //       setLoading(true);

// // //       // Prepare permissions data for bulk update
// // //       const permissionsToUpdate = [];

// // //       Object.entries(permissions).forEach(([module, enabled]) => {
// // //         if (enabled) {
// // //           // Include all permissions for the module
// // //           const modulePermissions =
// // //             permissionStructure[module]?.permissions || [];
// // //           modulePermissions.forEach((permission) => {
// // //             permissionsToUpdate.push({
// // //               module: module.charAt(0).toUpperCase() + module.slice(1), // Capitalize first letter
// // //               permission: permission,
// // //             });
// // //           });
// // //         }
// // //       });

// // //       selectedStudies.forEach((irbStudy) => {
// // //         permissionsToUpdate.push({
// // //           module: "Study",
// // //           permission: irbStudy,
// // //         });
// // //       });

// // //       // Prepare the bulk update request
// // //       const updateRequest = {
// // //         userId: user.userId,
// // //         userRoles: [selectedRole], // Add the selected role to userRoles array
// // //         permissions: permissionsToUpdate,
// // //       };

// // //       // Update permissions using bulk update endpoint
// // //       await updateUserPermissions(updateRequest);

// // //       // Call the onSave callback with the updated data
// // //       onSave({
// // //         userRole: selectedRole,
// // //         userRoles: [selectedRole],
// // //         permissions: permissions,
// // //         studies: selectedStudies,
// // //       });

// // //       onClose();
// // //     } catch (err) {
// // //       console.error("Error updating permissions:", err);
// // //       setError("Failed to update permissions");
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const handleClose = () => {
// // //     setSelectedRole("");
// // //     setPermissions({});
// // //     setLoading(false);
// // //     setError(null);
// // //     setUserPermissions([]);
// // //     setSelectedStudies([]);
// // //     onClose();
// // //   };

// // //   return (
// // //     <Dialog
// // //       open={open}
// // //       onClose={handleClose}
// // //       maxWidth="md"
// // //       fullWidth
// // //       PaperProps={{
// // //         sx: {
// // //           borderRadius: 2,
// // //           boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
// // //         },
// // //       }}
// // //     >
// // //       <DialogTitle
// // //         sx={{
// // //           display: "flex",
// // //           justifyContent: "space-between",
// // //           alignItems: "center",
// // //           pb: 2,
// // //         }}
// // //       >
// // //         <Typography variant="h6" sx={{ fontWeight: 600, color: maroon }}>
// // //           Edit User Permissions
// // //         </Typography>
// // //         <IconButton onClick={handleClose} size="small">
// // //           <CloseIcon />
// // //         </IconButton>
// // //       </DialogTitle>

// // //       <DialogContent sx={{ p: 3 }}>
// // //         {loading && (
// // //           <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
// // //             <CircularProgress sx={{ color: maroon }} />
// // //           </Box>
// // //         )}

// // //         {error && (
// // //           <Alert severity="error" sx={{ mb: 3 }}>
// // //             {error}
// // //           </Alert>
// // //         )}

// // //         {!loading && !error && (
// // //           <>
// // //             {/* Role Selection */}
// // //             <FormControl fullWidth sx={{ mb: 3 }}>
// // //               <InputLabel>User Role</InputLabel>
// // //               <Select
// // //                 value={selectedRole}
// // //                 onChange={handleRoleChange}
// // //                 label="User Role"
// // //                 sx={{
// // //                   "& .MuiOutlinedInput-root": {
// // //                     "&:hover fieldset": {
// // //                       borderColor: maroon,
// // //                     },
// // //                     "&.Mui-focused fieldset": {
// // //                       borderColor: maroon,
// // //                     },
// // //                   },
// // //                 }}
// // //               >
// // //                 {roleOptions.map((role) => (
// // //                   <MenuItem key={role} value={role}>
// // //                     {role}
// // //                   </MenuItem>
// // //                 ))}
// // //               </Select>
// // //             </FormControl>

// // //             {/* Tooltip */}
// // //             {selectedRole && (
// // //               <Alert
// // //                 severity="info"
// // //                 sx={{
// // //                   mb: 3,
// // //                   backgroundColor: maroon,
// // //                   color: "white",
// // //                   "& .MuiAlert-icon": {
// // //                     color: "white",
// // //                   },
// // //                 }}
// // //               >
// // //                 Permissions are pre-determined for this role.
// // //               </Alert>
// // //             )}

// // //             {/* User Role Overview */}
// // //             {selectedRole && (
// // //               <Box sx={{ mb: 3 }}>
// // //                 <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
// // //                   User Role Overview
// // //                 </Typography>
// // //                 <Typography variant="body2" color="text.secondary">
// // //                   {roleDescriptions[selectedRole]}
// // //                 </Typography>
// // //               </Box>
// // //             )}

// // //             {/* Data Permissions List */}
// // //             {selectedRole && (
// // //               <Box sx={{ mb: 3 }}>
// // //                 <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2 }}>
// // //                   Data Permissions
// // //                 </Typography>

// // //                 {studiesLoading ? (
// // //                   <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
// // //                     <CircularProgress size={24} sx={{ color: maroon }} />
// // //                   </Box>
// // //                 ) : (
// // //                   <List>
// // //                     <ListItem
// // //                       sx={{
// // //                         backgroundColor: "rgba(80, 0, 0, 0.1)",
// // //                         borderRadius: 1,
// // //                         mb: 0.5,
// // //                       }}
// // //                     >
// // //                       <ListItemIcon>
// // //                         <Checkbox
// // //                           checked={allStudiesSelected}
// // //                           onChange={(e) =>
// // //                             handleAllStudiesToggle(e.target.checked)
// // //                           }
// // //                           sx={{ color: maroon }}
// // //                         />
// // //                       </ListItemIcon>
// // //                       <ListItemText
// // //                         primary="All Studies"
// // //                         sx={{ fontWeight: 600 }}
// // //                       />
// // //                     </ListItem>

// // //                     {studies.map((study) => (
// // //                       <ListItem key={study.irbStudy} sx={{ pl: 6 }}>
// // //                         <ListItemIcon>
// // //                           <Checkbox
// // //                             checked={selectedStudies.includes(study.irbStudy)}
// // //                             onChange={() => handleStudyToggle(study.irbStudy)}
// // //                             sx={{ color: maroon }}
// // //                           />
// // //                         </ListItemIcon>
// // //                         <ListItemText primary={study.name} />
// // //                       </ListItem>
// // //                     ))}
// // //                   </List>
// // //                 )}
// // //               </Box>
// // //             )}

// // //             {/* Permissions List */}
// // //             {selectedRole && (
// // //               <Box>
// // //                 <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2 }}>
// // //                   Module Permissions
// // //                 </Typography>

// // //                 <List>
// // //                   {Object.entries(permissionStructure).map(
// // //                     ([sectionKey, sectionData]) => (
// // //                       <Box key={sectionKey}>
// // //                         <ListItem
// // //                           button
// // //                           onClick={() => toggleSection(sectionKey)}
// // //                           sx={{
// // //                             backgroundColor: expandedSections[sectionKey]
// // //                               ? "rgba(80, 0, 0, 0.1)"
// // //                               : "transparent",
// // //                             borderRadius: 1,
// // //                             mb: 0.5,
// // //                           }}
// // //                         >
// // //                           <ListItemIcon>
// // //                             <Checkbox
// // //                               checked={permissions[sectionKey] || false}
// // //                               onChange={(e) =>
// // //                                 handlePermissionChange(
// // //                                   sectionKey,
// // //                                   e.target.checked
// // //                                 )
// // //                               }
// // //                               sx={{ color: maroon }}
// // //                             />
// // //                           </ListItemIcon>
// // //                           <ListItemText
// // //                             primary={sectionData.label}
// // //                             sx={{ fontWeight: 600 }}
// // //                           />
// // //                           {expandedSections[sectionKey] ? (
// // //                             <ExpandLessIcon />
// // //                           ) : (
// // //                             <ExpandMoreIcon />
// // //                           )}
// // //                         </ListItem>

// // //                         {expandedSections[sectionKey] && (
// // //                           <List component="div" disablePadding>
// // //                             {sectionData.permissions.map((permission) => (
// // //                               <ListItem key={permission} sx={{ pl: 6 }}>
// // //                                 <ListItemIcon>
// // //                                   <Checkbox
// // //                                     checked={permissions[sectionKey] || false}
// // //                                     disabled
// // //                                     sx={{ color: maroon }}
// // //                                   />
// // //                                 </ListItemIcon>
// // //                                 <ListItemText primary={permission} />
// // //                               </ListItem>
// // //                             ))}
// // //                           </List>
// // //                         )}
// // //                       </Box>
// // //                     )
// // //                   )}
// // //                 </List>
// // //               </Box>
// // //             )}
// // //           </>
// // //         )}
// // //       </DialogContent>

// // //       <DialogActions sx={{ p: 3, gap: 1 }}>
// // //         <Button
// // //           onClick={handleClose}
// // //           variant="outlined"
// // //           sx={{
// // //             borderColor: "#8B4513",
// // //             color: "#8B4513",
// // //             textTransform: "none",
// // //             "&:hover": {
// // //               borderColor: "#8B4513",
// // //               backgroundColor: "rgba(139, 69, 19, 0.1)",
// // //             },
// // //           }}
// // //         >
// // //           CANCEL
// // //         </Button>
// // //         <Button
// // //           onClick={handleSave}
// // //           variant="contained"
// // //           disabled={!selectedRole || loading}
// // //           sx={{
// // //             backgroundColor: maroon,
// // //             color: "white",
// // //             textTransform: "none",
// // //             "&:hover": {
// // //               backgroundColor: "#4a0000",
// // //             },
// // //             "&:disabled": {
// // //               backgroundColor: "#ccc",
// // //               color: "#666",
// // //             },
// // //           }}
// // //         >
// // //           {loading ? (
// // //             <CircularProgress size={20} sx={{ color: "white" }} />
// // //           ) : (
// // //             "SAVE CHANGES"
// // //           )}
// // //         </Button>
// // //       </DialogActions>
// // //     </Dialog>
// // //   );
// // // };

// // // export default EditUserPermissionsModal;

// // import React, { useState, useEffect, useCallback, useMemo } from "react";
// // import {
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   Button,
// //   FormControl,
// //   InputLabel,
// //   Select,
// //   MenuItem,
// //   Box,
// //   Typography,
// //   Checkbox,
// //   FormControlLabel,
// //   List,
// //   ListItem,
// //   ListItemIcon,
// //   ListItemText,
// //   IconButton,
// //   Alert,
// //   Divider,
// //   CircularProgress,
// //   Chip,
// // } from "@mui/material";
// // import {
// //   Close as CloseIcon,
// //   ExpandLess as ExpandLessIcon,
// //   ExpandMore as ExpandMoreIcon,
// // } from "@mui/icons-material";
// // import {
// //   getUserPermissionsByUserId,
// //   updateUserPermissions,
// //   fetchActiveStudies,
// // } from "../utils/api";

// // const maroon = "#500000";

// // const EditUserPermissionsModal = ({ open, onClose, onSave, user }) => {
// //   const [selectedRole, setSelectedRole] = useState("");
// //   const [permissions, setPermissions] = useState({});
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [userPermissions, setUserPermissions] = useState([]);
// //   const [studies, setStudies] = useState([]);
// //   const [studiesLoading, setStudiesLoading] = useState(false);
// //   const [selectedStudies, setSelectedStudies] = useState([]);
// //   const [expandedSections, setExpandedSections] = useState({
// //     admin: true,
// //     biobank: true,
// //     researcher: true,
// //   });

// //   const roleOptions = [
// //     "Super Admin",
// //     "System Manager",
// //     "BioBank Coordinator",
// //     "Clinic Coordinator",
// //     "Sample Technician",
// //     "Regulatory Admin",
// //     "Viewer",
// //   ];

// //   const roleDescriptions = {
// //     "Super Admin":
// //       "Full system authority. This includes unrestricted access to every functions in the Admin, BioBank and Researcher modules.",
// //     "System Manager":
// //       "Responsible for platform setup and governance. Can configure users, manage data visibility, and oversee auditing activities, but cannot enact any regulatory concerns.",
// //     "BioBank Coordinator":
// //       "Oversees BioBank operational activities. Manages kits, scheduling, and supervision sample logistics, but does not handle patient health records or regulatory actions.",
// //     "Clinic Coordinator":
// //       "Handles day-to-day workflows, focused on patient scheduling, intake, and collection of samples during visits.",
// //     "Sample Technician":
// //       "Focused solely on laboratory workflows. Processes collected samples into aliquots and manages check-ins/out for shipments.",
// //     "Regulatory Admin":
// //       "Read-only access for compliance and regulatory oversight. Provides oversight of consent, patient traceability, and sample lifecycle data.",
// //     Viewer:
// //       "Read-only access for operational oversight. Provides visibility into patient scheduling, patient flow, and sample collection, without rights to enact changes or visibility.",
// //   };

// //   const permissionStructure = {
// //     admin: {
// //       label: "Admin",
// //       permissions: [
// //         "Task Management",
// //         "User Management",
// //         "Sample Data",
// //         "Participant Data",
// //         "Program Directory",
// //       ],
// //     },
// //     biobank: {
// //       label: "BioBank",
// //       permissions: [
// //         "Participant Scheduling",
// //         "Collection Kits",
// //         "Participant Check-in",
// //         "Sample Collection",
// //         "Sample Processing",
// //         "Aliquot Management",
// //       ],
// //     },
// //     researcher: {
// //       label: "Researcher",
// //       permissions: ["Data Access", "Data Export"],
// //     },
// //   };

// //   // Predefined role permissions
// //   const rolePermissions = useMemo(
// //     () => ({
// //       "Super Admin": {
// //         admin: true,
// //         biobank: true,
// //         researcher: true,
// //       },
// //       "System Manager": {
// //         admin: true,
// //         biobank: true,
// //         researcher: false,
// //       },
// //       "BioBank Coordinator": {
// //         admin: false,
// //         biobank: true,
// //         researcher: false,
// //       },
// //       "Clinic Coordinator": {
// //         admin: false,
// //         biobank: true,
// //         researcher: false,
// //       },
// //       "Sample Technician": {
// //         admin: false,
// //         biobank: true,
// //         researcher: false,
// //       },
// //       "Regulatory Admin": {
// //         admin: true,
// //         biobank: false,
// //         researcher: false,
// //       },
// //       Viewer: {
// //         admin: true,
// //         biobank: true,
// //         researcher: false,
// //       },
// //     }),
// //     []
// //   );

// //   const loadUserPermissions = useCallback(async () => {
// //     if (!user?.userId) return;

// //     try {
// //       setLoading(true);
// //       const permissions = await getUserPermissionsByUserId(user.userId);
// //       setUserPermissions(permissions);

// //       const existingStudyPermissions = (permissions || [])
// //         .filter((permission) => permission.module?.toLowerCase() === "study")
// //         .map((permission) => permission.permission);
// //       setSelectedStudies(existingStudyPermissions);

// //       // Initialize permissions based on user's current role
// //       const userRole =
// //         Array.isArray(user.userRoles) && user.userRoles.length > 0
// //           ? user.userRoles[0]
// //           : user.userRole || "";
// //       const currentPermissions = rolePermissions[userRole] || {};
// //       setPermissions(currentPermissions);

// //       // If user has existing permissions, load them
// //       if (permissions && permissions.length > 0) {
// //         const existingPermissions = {};

// //         permissions.forEach((permission) => {
// //           if (permission.module) {
// //             existingPermissions[permission.module.toLowerCase()] = true;
// //           }
// //         });

// //         setPermissions(existingPermissions);
// //       }
// //     } catch (err) {
// //       console.error("Error loading user permissions:", err);
// //       setError("Failed to load user permissions");
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, [user?.userId, user?.userRole, user?.userRoles, rolePermissions]);

// //   useEffect(() => {
// //     const loadStudies = async () => {
// //       try {
// //         setStudiesLoading(true);
// //         const activeStudies = await fetchActiveStudies();
// //         setStudies(activeStudies);
// //       } catch (err) {
// //         console.error("Error loading studies:", err);
// //         setStudies([]);
// //       } finally {
// //         setStudiesLoading(false);
// //       }
// //     };

// //     if (open) {
// //       loadStudies();
// //     }
// //   }, [open]);

// //   useEffect(() => {
// //     if (open && user) {
// //       // Handle both single userRole and array userRoles
// //       const userRole =
// //         Array.isArray(user.userRoles) && user.userRoles.length > 0
// //           ? user.userRoles[0]
// //           : user.userRole || "";
// //       setSelectedRole(userRole);
// //       setError(null);
// //       loadUserPermissions();
// //     }
// //   }, [open, user, loadUserPermissions]);

// //   const handleRoleChange = (event) => {
// //     const role = event.target.value;
// //     setSelectedRole(role);

// //     // Update permissions based on selected role
// //     const rolePerms = rolePermissions[role] || {};
// //     setPermissions(rolePerms);
// //   };

// //   const handlePermissionChange = (section, checked) => {
// //     // Roles are predefined — only section-level changes are allowed.
// //     setPermissions((prev) => ({
// //       ...prev,
// //       [section]: checked,
// //     }));
// //   };

// //   const handleStudyToggle = (irbStudy) => {
// //     setSelectedStudies((prev) =>
// //       prev.includes(irbStudy)
// //         ? prev.filter((s) => s !== irbStudy)
// //         : [...prev, irbStudy]
// //     );
// //   };

// //   const handleAllStudiesToggle = (checked) => {
// //     if (checked) {
// //       setSelectedStudies(studies.map((study) => study.irbStudy));
// //     } else {
// //       setSelectedStudies([]);
// //     }
// //   };

// //   const allStudiesSelected =
// //     studies.length > 0 && selectedStudies.length === studies.length;

// //   const hasStudySelected = selectedStudies.length > 0;

// //   const toggleSection = (section) => {
// //     setExpandedSections((prev) => ({
// //       ...prev,
// //       [section]: !prev[section],
// //     }));
// //   };

// //   const handleSave = async () => {
// //     try {
// //       setLoading(true);

// //       // Prepare permissions data for bulk update
// //       const permissionsToUpdate = [];

// //       Object.entries(permissions).forEach(([module, enabled]) => {
// //         if (enabled && hasStudySelected) {
// //           // Include all permissions for the module
// //           const modulePermissions =
// //             permissionStructure[module]?.permissions || [];
// //           modulePermissions.forEach((permission) => {
// //             permissionsToUpdate.push({
// //               module: module.charAt(0).toUpperCase() + module.slice(1), // Capitalize first letter
// //               permission: permission,
// //             });
// //           });
// //         }
// //       });

// //       selectedStudies.forEach((irbStudy) => {
// //         permissionsToUpdate.push({
// //           module: "Study",
// //           permission: irbStudy,
// //         });
// //       });

// //       // Prepare the bulk update request
// //       const updateRequest = {
// //         userId: user.userId,
// //         userRoles: [selectedRole], // Add the selected role to userRoles array
// //         permissions: permissionsToUpdate,
// //       };

// //       // Update permissions using bulk update endpoint
// //       await updateUserPermissions(updateRequest);

// //       // Call the onSave callback with the updated data
// //       onSave({
// //         userRole: selectedRole,
// //         userRoles: [selectedRole],
// //         permissions: permissions,
// //         studies: selectedStudies,
// //       });

// //       onClose();
// //     } catch (err) {
// //       console.error("Error updating permissions:", err);
// //       setError("Failed to update permissions");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleClose = () => {
// //     setSelectedRole("");
// //     setPermissions({});
// //     setLoading(false);
// //     setError(null);
// //     setUserPermissions([]);
// //     setSelectedStudies([]);
// //     onClose();
// //   };

// //   return (
// //     <Dialog
// //       open={open}
// //       onClose={handleClose}
// //       maxWidth="md"
// //       fullWidth
// //       PaperProps={{
// //         sx: {
// //           borderRadius: 2,
// //           boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
// //         },
// //       }}
// //     >
// //       <DialogTitle
// //         sx={{
// //           display: "flex",
// //           justifyContent: "space-between",
// //           alignItems: "center",
// //           pb: 2,
// //         }}
// //       >
// //         <Typography variant="h6" sx={{ fontWeight: 600, color: maroon }}>
// //           Edit User Permissions
// //         </Typography>
// //         <IconButton onClick={handleClose} size="small">
// //           <CloseIcon />
// //         </IconButton>
// //       </DialogTitle>

// //       <DialogContent sx={{ p: 3 }}>
// //         {loading && (
// //           <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
// //             <CircularProgress sx={{ color: maroon }} />
// //           </Box>
// //         )}

// //         {error && (
// //           <Alert severity="error" sx={{ mb: 3 }}>
// //             {error}
// //           </Alert>
// //         )}

// //         {!loading && !error && (
// //           <>
// //             {/* Role Selection */}
// //             <FormControl fullWidth sx={{ mb: 3 }}>
// //               <InputLabel>User Role</InputLabel>
// //               <Select
// //                 value={selectedRole}
// //                 onChange={handleRoleChange}
// //                 label="User Role"
// //                 sx={{
// //                   "& .MuiOutlinedInput-root": {
// //                     "&:hover fieldset": {
// //                       borderColor: maroon,
// //                     },
// //                     "&.Mui-focused fieldset": {
// //                       borderColor: maroon,
// //                     },
// //                   },
// //                 }}
// //               >
// //                 {roleOptions.map((role) => (
// //                   <MenuItem key={role} value={role}>
// //                     {role}
// //                   </MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>

// //             {/* Tooltip */}
// //             {selectedRole && (
// //               <Alert
// //                 severity="info"
// //                 sx={{
// //                   mb: 3,
// //                   backgroundColor: maroon,
// //                   color: "white",
// //                   "& .MuiAlert-icon": {
// //                     color: "white",
// //                   },
// //                 }}
// //               >
// //                 Permissions are pre-determined for this role.
// //               </Alert>
// //             )}

// //             {/* User Role Overview */}
// //             {selectedRole && (
// //               <Box sx={{ mb: 3 }}>
// //                 <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
// //                   User Role Overview
// //                 </Typography>
// //                 <Typography variant="body2" color="text.secondary">
// //                   {roleDescriptions[selectedRole]}
// //                 </Typography>
// //               </Box>
// //             )}

// //             {/* Data Permissions List */}
// //             {selectedRole && (
// //               <Box sx={{ mb: 3 }}>
// //                 <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2 }}>
// //                   Data Permissions
// //                 </Typography>

// //                 {studiesLoading ? (
// //                   <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
// //                     <CircularProgress size={24} sx={{ color: maroon }} />
// //                   </Box>
// //                 ) : (
// //                   <List>
// //                     <ListItem
// //                       sx={{
// //                         backgroundColor: "rgba(80, 0, 0, 0.1)",
// //                         borderRadius: 1,
// //                         mb: 0.5,
// //                       }}
// //                     >
// //                       <ListItemIcon>
// //                         <Checkbox
// //                           checked={allStudiesSelected}
// //                           onChange={(e) =>
// //                             handleAllStudiesToggle(e.target.checked)
// //                           }
// //                           sx={{ color: maroon }}
// //                         />
// //                       </ListItemIcon>
// //                       <ListItemText
// //                         primary="All Studies"
// //                         sx={{ fontWeight: 600 }}
// //                       />
// //                     </ListItem>

// //                     {studies.map((study) => (
// //                       <ListItem key={study.irbStudy} sx={{ pl: 6 }}>
// //                         <ListItemIcon>
// //                           <Checkbox
// //                             checked={selectedStudies.includes(study.irbStudy)}
// //                             onChange={() => handleStudyToggle(study.irbStudy)}
// //                             sx={{ color: maroon }}
// //                           />
// //                         </ListItemIcon>
// //                         <ListItemText primary={study.name} />
// //                       </ListItem>
// //                     ))}
// //                   </List>
// //                 )}

// //                 {hasStudySelected && (
// //                   <Box sx={{ mt: 1.5, display: "flex", flexWrap: "wrap", gap: 0.5 }}>
// //                     {allStudiesSelected ? (
// //                       <Chip
// //                         label="Permission granted: All Studies"
// //                         size="small"
// //                         sx={{ backgroundColor: maroon, color: "white" }}
// //                       />
// //                     ) : (
// //                       studies
// //                         .filter((study) => selectedStudies.includes(study.irbStudy))
// //                         .map((study) => (
// //                           <Chip
// //                             key={study.irbStudy}
// //                             label={`Permission granted: ${study.name}`}
// //                             size="small"
// //                             sx={{ backgroundColor: maroon, color: "white" }}
// //                           />
// //                         ))
// //                     )}
// //                   </Box>
// //                 )}
// //               </Box>
// //             )}

// //             {/* Permissions List */}
// //             {selectedRole && (
// //               <Box>
// //                 <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2 }}>
// //                   Module Permissions
// //                 </Typography>

// //                 {!hasStudySelected && (
// //                   <Alert severity="warning" sx={{ mb: 2 }}>
// //                     Select at least one study above before granting module
// //                     permissions.
// //                   </Alert>
// //                 )}

// //                 <List>
// //                   {Object.entries(permissionStructure).map(
// //                     ([sectionKey, sectionData]) => (
// //                       <Box key={sectionKey}>
// //                         <ListItem
// //                           button
// //                           onClick={() => toggleSection(sectionKey)}
// //                           sx={{
// //                             backgroundColor: expandedSections[sectionKey]
// //                               ? "rgba(80, 0, 0, 0.1)"
// //                               : "transparent",
// //                             borderRadius: 1,
// //                             mb: 0.5,
// //                           }}
// //                         >
// //                           <ListItemIcon>
// //                             <Checkbox
// //                               checked={permissions[sectionKey] || false}
// //                               disabled={!hasStudySelected}
// //                               onChange={(e) =>
// //                                 handlePermissionChange(
// //                                   sectionKey,
// //                                   e.target.checked
// //                                 )
// //                               }
// //                               sx={{ color: maroon }}
// //                             />
// //                           </ListItemIcon>
// //                           <ListItemText
// //                             primary={sectionData.label}
// //                             sx={{ fontWeight: 600 }}
// //                           />
// //                           {expandedSections[sectionKey] ? (
// //                             <ExpandLessIcon />
// //                           ) : (
// //                             <ExpandMoreIcon />
// //                           )}
// //                         </ListItem>

// //                         {expandedSections[sectionKey] && (
// //                           <List component="div" disablePadding>
// //                             {sectionData.permissions.map((permission) => (
// //                               <ListItem key={permission} sx={{ pl: 6 }}>
// //                                 <ListItemIcon>
// //                                   <Checkbox
// //                                     checked={
// //                                       hasStudySelected &&
// //                                       (permissions[sectionKey] || false)
// //                                     }
// //                                     disabled
// //                                     sx={{ color: maroon }}
// //                                   />
// //                                 </ListItemIcon>
// //                                 <ListItemText primary={permission} />
// //                               </ListItem>
// //                             ))}
// //                           </List>
// //                         )}
// //                       </Box>
// //                     )
// //                   )}
// //                 </List>
// //               </Box>
// //             )}
// //           </>
// //         )}
// //       </DialogContent>

// //       <DialogActions sx={{ p: 3, gap: 1 }}>
// //         <Button
// //           onClick={handleClose}
// //           variant="outlined"
// //           sx={{
// //             borderColor: "#8B4513",
// //             color: "#8B4513",
// //             textTransform: "none",
// //             "&:hover": {
// //               borderColor: "#8B4513",
// //               backgroundColor: "rgba(139, 69, 19, 0.1)",
// //             },
// //           }}
// //         >
// //           CANCEL
// //         </Button>
// //         <Button
// //           onClick={handleSave}
// //           variant="contained"
// //           disabled={
// //             !selectedRole ||
// //             loading ||
// //             (Object.values(permissions).some(Boolean) && !hasStudySelected)
// //           }
// //           sx={{
// //             backgroundColor: maroon,
// //             color: "white",
// //             textTransform: "none",
// //             "&:hover": {
// //               backgroundColor: "#4a0000",
// //             },
// //             "&:disabled": {
// //               backgroundColor: "#ccc",
// //               color: "#666",
// //             },
// //           }}
// //         >
// //           {loading ? (
// //             <CircularProgress size={20} sx={{ color: "white" }} />
// //           ) : (
// //             "SAVE CHANGES"
// //           )}
// //         </Button>
// //       </DialogActions>
// //     </Dialog>
// //   );
// // };

// // export default EditUserPermissionsModal;

// // import React, { useState, useEffect, useCallback, useMemo } from "react";
// // import {
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   Button,
// //   FormControl,
// //   InputLabel,
// //   Select,
// //   MenuItem,
// //   Box,
// //   Typography,
// //   Checkbox,
// //   FormControlLabel,
// //   List,
// //   ListItem,
// //   ListItemIcon,
// //   ListItemText,
// //   IconButton,
// //   Alert,
// //   Divider,
// //   CircularProgress,
// // } from "@mui/material";
// // import {
// //   Close as CloseIcon,
// //   ExpandLess as ExpandLessIcon,
// //   ExpandMore as ExpandMoreIcon,
// // } from "@mui/icons-material";
// // import {
// //   getUserPermissionsByUserId,
// //   updateUserPermissions,
// //   fetchActiveStudies,
// // } from "../utils/api";

// // const maroon = "#500000";

// // const EditUserPermissionsModal = ({ open, onClose, onSave, user }) => {
// //   const [selectedRole, setSelectedRole] = useState("");
// //   const [permissions, setPermissions] = useState({});
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [userPermissions, setUserPermissions] = useState([]);
// //   const [studies, setStudies] = useState([]);
// //   const [studiesLoading, setStudiesLoading] = useState(false);
// //   const [selectedStudies, setSelectedStudies] = useState([]);
// //   const [expandedSections, setExpandedSections] = useState({
// //     admin: true,
// //     biobank: true,
// //     researcher: true,
// //   });

// //   const roleOptions = [
// //     "Super Admin",
// //     "System Manager",
// //     "BioBank Coordinator",
// //     "Clinic Coordinator",
// //     "Sample Technician",
// //     "Regulatory Admin",
// //     "Viewer",
// //   ];

// //   const roleDescriptions = {
// //     "Super Admin":
// //       "Full system authority. This includes unrestricted access to every functions in the Admin, BioBank and Researcher modules.",
// //     "System Manager":
// //       "Responsible for platform setup and governance. Can configure users, manage data visibility, and oversee auditing activities, but cannot enact any regulatory concerns.",
// //     "BioBank Coordinator":
// //       "Oversees BioBank operational activities. Manages kits, scheduling, and supervision sample logistics, but does not handle patient health records or regulatory actions.",
// //     "Clinic Coordinator":
// //       "Handles day-to-day workflows, focused on patient scheduling, intake, and collection of samples during visits.",
// //     "Sample Technician":
// //       "Focused solely on laboratory workflows. Processes collected samples into aliquots and manages check-ins/out for shipments.",
// //     "Regulatory Admin":
// //       "Read-only access for compliance and regulatory oversight. Provides oversight of consent, patient traceability, and sample lifecycle data.",
// //     Viewer:
// //       "Read-only access for operational oversight. Provides visibility into patient scheduling, patient flow, and sample collection, without rights to enact changes or visibility.",
// //   };

// //   const permissionStructure = {
// //     admin: {
// //       label: "Admin",
// //       permissions: [
// //         "Task Management",
// //         "User Management",
// //         "Sample Data",
// //         "Participant Data",
// //         "Program Directory",
// //       ],
// //     },
// //     biobank: {
// //       label: "BioBank",
// //       permissions: [
// //         "Participant Scheduling",
// //         "Collection Kits",
// //         "Participant Check-in",
// //         "Sample Collection",
// //         "Sample Processing",
// //         "Aliquot Management",
// //       ],
// //     },
// //     researcher: {
// //       label: "Researcher",
// //       permissions: ["Data Access", "Data Export"],
// //     },
// //   };

// //   // Predefined role permissions
// //   const rolePermissions = useMemo(
// //     () => ({
// //       "Super Admin": {
// //         admin: true,
// //         biobank: true,
// //         researcher: true,
// //       },
// //       "System Manager": {
// //         admin: true,
// //         biobank: true,
// //         researcher: false,
// //       },
// //       "BioBank Coordinator": {
// //         admin: false,
// //         biobank: true,
// //         researcher: false,
// //       },
// //       "Clinic Coordinator": {
// //         admin: false,
// //         biobank: true,
// //         researcher: false,
// //       },
// //       "Sample Technician": {
// //         admin: false,
// //         biobank: true,
// //         researcher: false,
// //       },
// //       "Regulatory Admin": {
// //         admin: true,
// //         biobank: false,
// //         researcher: false,
// //       },
// //       Viewer: {
// //         admin: true,
// //         biobank: true,
// //         researcher: false,
// //       },
// //     }),
// //     []
// //   );

// //   const loadUserPermissions = useCallback(async () => {
// //     if (!user?.userId) return;

// //     try {
// //       setLoading(true);
// //       const permissions = await getUserPermissionsByUserId(user.userId);
// //       setUserPermissions(permissions);

// //       const existingStudyPermissions = (permissions || [])
// //         .filter((permission) => permission.module?.toLowerCase() === "study")
// //         .map((permission) => permission.permission);
// //       setSelectedStudies(existingStudyPermissions);

// //       // Initialize permissions based on user's current role
// //       const userRole =
// //         Array.isArray(user.userRoles) && user.userRoles.length > 0
// //           ? user.userRoles[0]
// //           : user.userRole || "";
// //       const currentPermissions = rolePermissions[userRole] || {};
// //       setPermissions(currentPermissions);

// //       // If user has existing permissions, load them
// //       if (permissions && permissions.length > 0) {
// //         const existingPermissions = {};

// //         permissions.forEach((permission) => {
// //           if (permission.module) {
// //             existingPermissions[permission.module.toLowerCase()] = true;
// //           }
// //         });

// //         setPermissions(existingPermissions);
// //       }
// //     } catch (err) {
// //       console.error("Error loading user permissions:", err);
// //       setError("Failed to load user permissions");
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, [user?.userId, user?.userRole, user?.userRoles, rolePermissions]);

// //   useEffect(() => {
// //     const loadStudies = async () => {
// //       try {
// //         setStudiesLoading(true);
// //         const activeStudies = await fetchActiveStudies();
// //         setStudies(activeStudies);
// //       } catch (err) {
// //         console.error("Error loading studies:", err);
// //         setStudies([]);
// //       } finally {
// //         setStudiesLoading(false);
// //       }
// //     };

// //     if (open) {
// //       loadStudies();
// //     }
// //   }, [open]);

// //   useEffect(() => {
// //     if (open && user) {
// //       // Handle both single userRole and array userRoles
// //       const userRole =
// //         Array.isArray(user.userRoles) && user.userRoles.length > 0
// //           ? user.userRoles[0]
// //           : user.userRole || "";
// //       setSelectedRole(userRole);
// //       setError(null);
// //       loadUserPermissions();
// //     }
// //   }, [open, user, loadUserPermissions]);

// //   const handleRoleChange = (event) => {
// //     const role = event.target.value;
// //     setSelectedRole(role);

// //     // Update permissions based on selected role
// //     const rolePerms = rolePermissions[role] || {};
// //     setPermissions(rolePerms);
// //   };

// //   const handlePermissionChange = (section, checked) => {
// //     // Roles are predefined — only section-level changes are allowed.
// //     setPermissions((prev) => ({
// //       ...prev,
// //       [section]: checked,
// //     }));
// //   };

// //   const handleStudyToggle = (irbStudy) => {
// //     setSelectedStudies((prev) =>
// //       prev.includes(irbStudy)
// //         ? prev.filter((s) => s !== irbStudy)
// //         : [...prev, irbStudy]
// //     );
// //   };

// //   const handleAllStudiesToggle = (checked) => {
// //     if (checked) {
// //       setSelectedStudies(studies.map((study) => study.irbStudy));
// //     } else {
// //       setSelectedStudies([]);
// //     }
// //   };

// //   const allStudiesSelected =
// //     studies.length > 0 && selectedStudies.length === studies.length;

// //   const toggleSection = (section) => {
// //     setExpandedSections((prev) => ({
// //       ...prev,
// //       [section]: !prev[section],
// //     }));
// //   };

// //   const handleSave = async () => {
// //     try {
// //       setLoading(true);

// //       // Prepare permissions data for bulk update
// //       const permissionsToUpdate = [];

// //       Object.entries(permissions).forEach(([module, enabled]) => {
// //         if (enabled) {
// //           // Include all permissions for the module
// //           const modulePermissions =
// //             permissionStructure[module]?.permissions || [];
// //           modulePermissions.forEach((permission) => {
// //             permissionsToUpdate.push({
// //               module: module.charAt(0).toUpperCase() + module.slice(1), // Capitalize first letter
// //               permission: permission,
// //             });
// //           });
// //         }
// //       });

// //       selectedStudies.forEach((irbStudy) => {
// //         permissionsToUpdate.push({
// //           module: "Study",
// //           permission: irbStudy,
// //         });
// //       });

// //       // Prepare the bulk update request
// //       const updateRequest = {
// //         userId: user.userId,
// //         userRoles: [selectedRole], // Add the selected role to userRoles array
// //         permissions: permissionsToUpdate,
// //       };

// //       // Update permissions using bulk update endpoint
// //       await updateUserPermissions(updateRequest);

// //       // Call the onSave callback with the updated data
// //       onSave({
// //         userRole: selectedRole,
// //         userRoles: [selectedRole],
// //         permissions: permissions,
// //         studies: selectedStudies,
// //       });

// //       onClose();
// //     } catch (err) {
// //       console.error("Error updating permissions:", err);
// //       setError("Failed to update permissions");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleClose = () => {
// //     setSelectedRole("");
// //     setPermissions({});
// //     setLoading(false);
// //     setError(null);
// //     setUserPermissions([]);
// //     setSelectedStudies([]);
// //     onClose();
// //   };

// //   return (
// //     <Dialog
// //       open={open}
// //       onClose={handleClose}
// //       maxWidth="md"
// //       fullWidth
// //       PaperProps={{
// //         sx: {
// //           borderRadius: 2,
// //           boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
// //         },
// //       }}
// //     >
// //       <DialogTitle
// //         sx={{
// //           display: "flex",
// //           justifyContent: "space-between",
// //           alignItems: "center",
// //           pb: 2,
// //         }}
// //       >
// //         <Typography variant="h6" sx={{ fontWeight: 600, color: maroon }}>
// //           Edit User Permissions
// //         </Typography>
// //         <IconButton onClick={handleClose} size="small">
// //           <CloseIcon />
// //         </IconButton>
// //       </DialogTitle>

// //       <DialogContent sx={{ p: 3 }}>
// //         {loading && (
// //           <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
// //             <CircularProgress sx={{ color: maroon }} />
// //           </Box>
// //         )}

// //         {error && (
// //           <Alert severity="error" sx={{ mb: 3 }}>
// //             {error}
// //           </Alert>
// //         )}

// //         {!loading && !error && (
// //           <>
// //             {/* Role Selection */}
// //             <FormControl fullWidth sx={{ mb: 3 }}>
// //               <InputLabel>User Role</InputLabel>
// //               <Select
// //                 value={selectedRole}
// //                 onChange={handleRoleChange}
// //                 label="User Role"
// //                 sx={{
// //                   "& .MuiOutlinedInput-root": {
// //                     "&:hover fieldset": {
// //                       borderColor: maroon,
// //                     },
// //                     "&.Mui-focused fieldset": {
// //                       borderColor: maroon,
// //                     },
// //                   },
// //                 }}
// //               >
// //                 {roleOptions.map((role) => (
// //                   <MenuItem key={role} value={role}>
// //                     {role}
// //                   </MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>

// //             {/* Tooltip */}
// //             {selectedRole && (
// //               <Alert
// //                 severity="info"
// //                 sx={{
// //                   mb: 3,
// //                   backgroundColor: maroon,
// //                   color: "white",
// //                   "& .MuiAlert-icon": {
// //                     color: "white",
// //                   },
// //                 }}
// //               >
// //                 Permissions are pre-determined for this role.
// //               </Alert>
// //             )}

// //             {/* User Role Overview */}
// //             {selectedRole && (
// //               <Box sx={{ mb: 3 }}>
// //                 <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
// //                   User Role Overview
// //                 </Typography>
// //                 <Typography variant="body2" color="text.secondary">
// //                   {roleDescriptions[selectedRole]}
// //                 </Typography>
// //               </Box>
// //             )}

// //             {/* Data Permissions List */}
// //             {selectedRole && (
// //               <Box sx={{ mb: 3 }}>
// //                 <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2 }}>
// //                   Data Permissions
// //                 </Typography>

// //                 {studiesLoading ? (
// //                   <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
// //                     <CircularProgress size={24} sx={{ color: maroon }} />
// //                   </Box>
// //                 ) : (
// //                   <List>
// //                     <ListItem
// //                       sx={{
// //                         backgroundColor: "rgba(80, 0, 0, 0.1)",
// //                         borderRadius: 1,
// //                         mb: 0.5,
// //                       }}
// //                     >
// //                       <ListItemIcon>
// //                         <Checkbox
// //                           checked={allStudiesSelected}
// //                           onChange={(e) =>
// //                             handleAllStudiesToggle(e.target.checked)
// //                           }
// //                           sx={{ color: maroon }}
// //                         />
// //                       </ListItemIcon>
// //                       <ListItemText
// //                         primary="All Studies"
// //                         sx={{ fontWeight: 600 }}
// //                       />
// //                     </ListItem>

// //                     {studies.map((study) => (
// //                       <ListItem key={study.irbStudy} sx={{ pl: 6 }}>
// //                         <ListItemIcon>
// //                           <Checkbox
// //                             checked={selectedStudies.includes(study.irbStudy)}
// //                             onChange={() => handleStudyToggle(study.irbStudy)}
// //                             sx={{ color: maroon }}
// //                           />
// //                         </ListItemIcon>
// //                         <ListItemText primary={study.name} />
// //                       </ListItem>
// //                     ))}
// //                   </List>
// //                 )}
// //               </Box>
// //             )}

// //             {/* Permissions List */}
// //             {selectedRole && (
// //               <Box>
// //                 <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2 }}>
// //                   Module Permissions
// //                 </Typography>

// //                 <List>
// //                   {Object.entries(permissionStructure).map(
// //                     ([sectionKey, sectionData]) => (
// //                       <Box key={sectionKey}>
// //                         <ListItem
// //                           button
// //                           onClick={() => toggleSection(sectionKey)}
// //                           sx={{
// //                             backgroundColor: expandedSections[sectionKey]
// //                               ? "rgba(80, 0, 0, 0.1)"
// //                               : "transparent",
// //                             borderRadius: 1,
// //                             mb: 0.5,
// //                           }}
// //                         >
// //                           <ListItemIcon>
// //                             <Checkbox
// //                               checked={permissions[sectionKey] || false}
// //                               onChange={(e) =>
// //                                 handlePermissionChange(
// //                                   sectionKey,
// //                                   e.target.checked
// //                                 )
// //                               }
// //                               sx={{ color: maroon }}
// //                             />
// //                           </ListItemIcon>
// //                           <ListItemText
// //                             primary={sectionData.label}
// //                             sx={{ fontWeight: 600 }}
// //                           />
// //                           {expandedSections[sectionKey] ? (
// //                             <ExpandLessIcon />
// //                           ) : (
// //                             <ExpandMoreIcon />
// //                           )}
// //                         </ListItem>

// //                         {expandedSections[sectionKey] && (
// //                           <List component="div" disablePadding>
// //                             {sectionData.permissions.map((permission) => (
// //                               <ListItem key={permission} sx={{ pl: 6 }}>
// //                                 <ListItemIcon>
// //                                   <Checkbox
// //                                     checked={permissions[sectionKey] || false}
// //                                     disabled
// //                                     sx={{ color: maroon }}
// //                                   />
// //                                 </ListItemIcon>
// //                                 <ListItemText primary={permission} />
// //                               </ListItem>
// //                             ))}
// //                           </List>
// //                         )}
// //                       </Box>
// //                     )
// //                   )}
// //                 </List>
// //               </Box>
// //             )}
// //           </>
// //         )}
// //       </DialogContent>

// //       <DialogActions sx={{ p: 3, gap: 1 }}>
// //         <Button
// //           onClick={handleClose}
// //           variant="outlined"
// //           sx={{
// //             borderColor: "#8B4513",
// //             color: "#8B4513",
// //             textTransform: "none",
// //             "&:hover": {
// //               borderColor: "#8B4513",
// //               backgroundColor: "rgba(139, 69, 19, 0.1)",
// //             },
// //           }}
// //         >
// //           CANCEL
// //         </Button>
// //         <Button
// //           onClick={handleSave}
// //           variant="contained"
// //           disabled={!selectedRole || loading}
// //           sx={{
// //             backgroundColor: maroon,
// //             color: "white",
// //             textTransform: "none",
// //             "&:hover": {
// //               backgroundColor: "#4a0000",
// //             },
// //             "&:disabled": {
// //               backgroundColor: "#ccc",
// //               color: "#666",
// //             },
// //           }}
// //         >
// //           {loading ? (
// //             <CircularProgress size={20} sx={{ color: "white" }} />
// //           ) : (
// //             "SAVE CHANGES"
// //           )}
// //         </Button>
// //       </DialogActions>
// //     </Dialog>
// //   );
// // };

// // export default EditUserPermissionsModal;

// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Box,
//   Typography,
//   Checkbox,
//   FormControlLabel,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   IconButton,
//   Alert,
//   Divider,
//   CircularProgress,
//   Chip,
//   Grid,
//   Paper,
//   TextField,
//   InputAdornment,
// } from "@mui/material";
// import {
//   Close as CloseIcon,
//   ExpandLess as ExpandLessIcon,
//   ExpandMore as ExpandMoreIcon,
//   Search as SearchIcon,
//   ScienceOutlined as StudyIcon,
//   ViewModuleOutlined as ModuleIcon,
//   CheckCircle as CheckCircleIcon,
// } from "@mui/icons-material";
// import {
//   getUserPermissionsByUserId,
//   updateUserPermissions,
//   fetchActiveStudies,
// } from "../utils/api";

// const maroon = "#500000";

// const EditUserPermissionsModal = ({ open, onClose, onSave, user }) => {
//   const [selectedRole, setSelectedRole] = useState("");
//   const [permissions, setPermissions] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [userPermissions, setUserPermissions] = useState([]);
//   const [studies, setStudies] = useState([]);
//   const [studiesLoading, setStudiesLoading] = useState(false);
//   const [selectedStudies, setSelectedStudies] = useState([]);
//   const [studySearchTerm, setStudySearchTerm] = useState("");
//   const [expandedSections, setExpandedSections] = useState({
//     admin: true,
//     biobank: true,
//     researcher: true,
//   });

//   const roleOptions = [
//     "Super Admin",
//     "System Manager",
//     "BioBank Coordinator",
//     "Clinic Coordinator",
//     "Sample Technician",
//     "Regulatory Admin",
//     "Viewer",
//   ];

//   const roleDescriptions = {
//     "Super Admin":
//       "Full system authority. This includes unrestricted access to every functions in the Admin, BioBank and Researcher modules.",
//     "System Manager":
//       "Responsible for platform setup and governance. Can configure users, manage data visibility, and oversee auditing activities, but cannot enact any regulatory concerns.",
//     "BioBank Coordinator":
//       "Oversees BioBank operational activities. Manages kits, scheduling, and supervision sample logistics, but does not handle patient health records or regulatory actions.",
//     "Clinic Coordinator":
//       "Handles day-to-day workflows, focused on patient scheduling, intake, and collection of samples during visits.",
//     "Sample Technician":
//       "Focused solely on laboratory workflows. Processes collected samples into aliquots and manages check-ins/out for shipments.",
//     "Regulatory Admin":
//       "Read-only access for compliance and regulatory oversight. Provides oversight of consent, patient traceability, and sample lifecycle data.",
//     Viewer:
//       "Read-only access for operational oversight. Provides visibility into patient scheduling, patient flow, and sample collection, without rights to enact changes or visibility.",
//   };

//   const permissionStructure = {
//     admin: {
//       label: "Admin",
//       permissions: [
//         "Task Management",
//         "User Management",
//         "Sample Data",
//         "Participant Data",
//         "Program Directory",
//       ],
//     },
//     biobank: {
//       label: "BioBank",
//       permissions: [
//         "Participant Scheduling",
//         "Collection Kits",
//         "Participant Check-in",
//         "Sample Collection",
//         "Sample Processing",
//         "Aliquot Management",
//       ],
//     },
//     researcher: {
//       label: "Researcher",
//       permissions: ["Data Access", "Data Export"],
//     },
//   };

//   // Predefined role permissions
//   const rolePermissions = useMemo(
//     () => ({
//       "Super Admin": {
//         admin: true,
//         biobank: true,
//         researcher: true,
//       },
//       "System Manager": {
//         admin: true,
//         biobank: true,
//         researcher: false,
//       },
//       "BioBank Coordinator": {
//         admin: false,
//         biobank: true,
//         researcher: false,
//       },
//       "Clinic Coordinator": {
//         admin: false,
//         biobank: true,
//         researcher: false,
//       },
//       "Sample Technician": {
//         admin: false,
//         biobank: true,
//         researcher: false,
//       },
//       "Regulatory Admin": {
//         admin: true,
//         biobank: false,
//         researcher: false,
//       },
//       Viewer: {
//         admin: true,
//         biobank: true,
//         researcher: false,
//       },
//     }),
//     []
//   );

//   const loadUserPermissions = useCallback(async () => {
//     if (!user?.userId) return;

//     try {
//       setLoading(true);
//       const permissions = await getUserPermissionsByUserId(user.userId);
//       setUserPermissions(permissions);

//       const existingStudyPermissions = (permissions || [])
//         .filter((permission) => permission.module?.toLowerCase() === "study")
//         .map((permission) => permission.permission);
//       setSelectedStudies(existingStudyPermissions);

//       // Initialize permissions based on user's current role
//       const userRole =
//         Array.isArray(user.userRoles) && user.userRoles.length > 0
//           ? user.userRoles[0]
//           : user.userRole || "";
//       const currentPermissions = rolePermissions[userRole] || {};
//       setPermissions(currentPermissions);

//       // If user has existing permissions, load them
//       if (permissions && permissions.length > 0) {
//         const existingPermissions = {};

//         permissions.forEach((permission) => {
//           if (permission.module) {
//             existingPermissions[permission.module.toLowerCase()] = true;
//           }
//         });

//         setPermissions(existingPermissions);
//       }
//     } catch (err) {
//       console.error("Error loading user permissions:", err);
//       setError("Failed to load user permissions");
//     } finally {
//       setLoading(false);
//     }
//   }, [user?.userId, user?.userRole, user?.userRoles, rolePermissions]);

//   useEffect(() => {
//     const loadStudies = async () => {
//       try {
//         setStudiesLoading(true);
//         const activeStudies = await fetchActiveStudies();
//         setStudies(activeStudies);
//       } catch (err) {
//         console.error("Error loading studies:", err);
//         setStudies([]);
//       } finally {
//         setStudiesLoading(false);
//       }
//     };

//     if (open) {
//       loadStudies();
//     }
//   }, [open]);

//   useEffect(() => {
//     if (open && user) {
//       // Handle both single userRole and array userRoles
//       const userRole =
//         Array.isArray(user.userRoles) && user.userRoles.length > 0
//           ? user.userRoles[0]
//           : user.userRole || "";
//       setSelectedRole(userRole);
//       setError(null);
//       loadUserPermissions();
//     }
//   }, [open, user, loadUserPermissions]);

//   const handleRoleChange = (event) => {
//     const role = event.target.value;
//     setSelectedRole(role);

//     // Update permissions based on selected role
//     const rolePerms = rolePermissions[role] || {};
//     setPermissions(rolePerms);
//   };

//   const handlePermissionChange = (section, checked) => {
//     // Roles are predefined — only section-level changes are allowed.
//     setPermissions((prev) => ({
//       ...prev,
//       [section]: checked,
//     }));
//   };

//   const handleStudyToggle = (irbStudy) => {
//     setSelectedStudies((prev) =>
//       prev.includes(irbStudy)
//         ? prev.filter((s) => s !== irbStudy)
//         : [...prev, irbStudy]
//     );
//   };

//   const handleAllStudiesToggle = (checked) => {
//     if (checked) {
//       setSelectedStudies(studies.map((study) => study.irbStudy));
//     } else {
//       setSelectedStudies([]);
//     }
//   };

//   const allStudiesSelected =
//     studies.length > 0 && selectedStudies.length === studies.length;

//   const hasStudySelected = selectedStudies.length > 0;

//   const filteredStudies = studies.filter((study) =>
//     study.name.toLowerCase().includes(studySearchTerm.toLowerCase())
//   );

//   const toggleSection = (section) => {
//     setExpandedSections((prev) => ({
//       ...prev,
//       [section]: !prev[section],
//     }));
//   };

//   const handleSave = async () => {
//     try {
//       setLoading(true);

//       // Prepare permissions data for bulk update
//       const permissionsToUpdate = [];

//       Object.entries(permissions).forEach(([module, enabled]) => {
//         if (enabled && hasStudySelected) {
//           // Include all permissions for the module
//           const modulePermissions =
//             permissionStructure[module]?.permissions || [];
//           modulePermissions.forEach((permission) => {
//             permissionsToUpdate.push({
//               module: module.charAt(0).toUpperCase() + module.slice(1), // Capitalize first letter
//               permission: permission,
//             });
//           });
//         }
//       });

//       selectedStudies.forEach((irbStudy) => {
//         permissionsToUpdate.push({
//           module: "Study",
//           permission: irbStudy,
//         });
//       });

//       // Prepare the bulk update request
//       const updateRequest = {
//         userId: user.userId,
//         userRoles: [selectedRole], // Add the selected role to userRoles array
//         permissions: permissionsToUpdate,
//       };

//       // Update permissions using bulk update endpoint
//       await updateUserPermissions(updateRequest);

//       // Call the onSave callback with the updated data
//       onSave({
//         userRole: selectedRole,
//         userRoles: [selectedRole],
//         permissions: permissions,
//         studies: selectedStudies,
//       });

//       onClose();
//     } catch (err) {
//       console.error("Error updating permissions:", err);
//       setError("Failed to update permissions");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClose = () => {
//     setSelectedRole("");
//     setPermissions({});
//     setLoading(false);
//     setError(null);
//     setUserPermissions([]);
//     setSelectedStudies([]);
//     setStudySearchTerm("");
//     onClose();
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={handleClose}
//       maxWidth="lg"
//       fullWidth
//       PaperProps={{
//         sx: {
//           borderRadius: 2,
//           boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
//         },
//       }}
//     >
//       <DialogTitle
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           pb: 2,
//         }}
//       >
//         <Typography variant="h6" sx={{ fontWeight: 600, color: maroon }}>
//           Edit User Permissions
//         </Typography>
//         <IconButton onClick={handleClose} size="small">
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>

//       <DialogContent sx={{ p: 3 }}>
//         {loading && (
//           <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//             <CircularProgress sx={{ color: maroon }} />
//           </Box>
//         )}

//         {error && (
//           <Alert severity="error" sx={{ mb: 3 }}>
//             {error}
//           </Alert>
//         )}

//         {!loading && !error && (
//           <>
//             {/* Role Selection */}
//             <FormControl fullWidth sx={{ mb: 3 }}>
//               <InputLabel>User Role</InputLabel>
//               <Select
//                 value={selectedRole}
//                 onChange={handleRoleChange}
//                 label="User Role"
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     "&:hover fieldset": {
//                       borderColor: maroon,
//                     },
//                     "&.Mui-focused fieldset": {
//                       borderColor: maroon,
//                     },
//                   },
//                 }}
//               >
//                 {roleOptions.map((role) => (
//                   <MenuItem key={role} value={role}>
//                     {role}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             {/* Tooltip */}
//             {selectedRole && (
//               <Alert
//                 severity="info"
//                 sx={{
//                   mb: 3,
//                   backgroundColor: maroon,
//                   color: "white",
//                   "& .MuiAlert-icon": {
//                     color: "white",
//                   },
//                 }}
//               >
//                 Permissions are pre-determined for this role.
//               </Alert>
//             )}

//             {/* User Role Overview */}
//             {selectedRole && (
//               <Box sx={{ mb: 3 }}>
//                 <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
//                   User Role Overview
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   {roleDescriptions[selectedRole]}
//                 </Typography>
//               </Box>
//             )}

//             {!hasStudySelected && selectedRole && (
//               <Alert severity="warning" sx={{ mb: 2 }}>
//                 Select at least one study to grant module permissions for that study.
//               </Alert>
//             )}

//             {/* Module Permissions + Study Permissions, shown side by side */}
//             {selectedRole && (
//               <Grid container spacing={2.5}>
//                 {/* Study Permissions Panel */}
//                 <Grid item xs={12} md={6}>
//                   <Paper
//                     variant="outlined"
//                     sx={{
//                       borderRadius: 2,
//                       borderColor: "rgba(80, 0, 0, 0.25)",
//                       height: "100%",
//                       display: "flex",
//                       flexDirection: "column",
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 1,
//                         px: 2,
//                         py: 1.5,
//                         backgroundColor: "rgba(80, 0, 0, 0.06)",
//                         borderTopLeftRadius: 8,
//                         borderTopRightRadius: 8,
//                       }}
//                     >
//                       <StudyIcon sx={{ color: maroon, fontSize: 22 }} />
//                       <Typography sx={{ fontWeight: 700, color: maroon }}>
//                         Study Permissions
//                       </Typography>
//                       {hasStudySelected && (
//                         <Chip
//                           size="small"
//                           label={
//                             allStudiesSelected
//                               ? "All Studies"
//                               : `${selectedStudies.length} selected`
//                           }
//                           sx={{
//                             ml: "auto",
//                             backgroundColor: maroon,
//                             color: "white",
//                             fontWeight: 600,
//                           }}
//                         />
//                       )}
//                     </Box>

//                     <Box sx={{ p: 2, display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
//                       <TextField
//                         placeholder="Search studies..."
//                         size="small"
//                         fullWidth
//                         value={studySearchTerm}
//                         onChange={(e) => setStudySearchTerm(e.target.value)}
//                         sx={{
//                           mb: 1.5,
//                           "& .MuiOutlinedInput-root": {
//                             "&:hover fieldset": { borderColor: maroon },
//                             "&.Mui-focused fieldset": { borderColor: maroon },
//                           },
//                         }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <SearchIcon sx={{ fontSize: 20, color: "text.secondary" }} />
//                             </InputAdornment>
//                           ),
//                         }}
//                       />

//                       {studiesLoading ? (
//                         <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
//                           <CircularProgress size={24} sx={{ color: maroon }} />
//                         </Box>
//                       ) : (
//                         <>
//                           <FormControlLabel
//                             sx={{
//                               mx: 0,
//                               mb: 0.5,
//                               px: 1,
//                               py: 0.5,
//                               borderRadius: 1,
//                               backgroundColor: "rgba(80, 0, 0, 0.08)",
//                             }}
//                             control={
//                               <Checkbox
//                                 checked={allStudiesSelected}
//                                 indeterminate={
//                                   hasStudySelected && !allStudiesSelected
//                                 }
//                                 onChange={(e) =>
//                                   handleAllStudiesToggle(e.target.checked)
//                                 }
//                                 sx={{ color: maroon }}
//                               />
//                             }
//                             label={
//                               <Typography sx={{ fontWeight: 600 }}>
//                                 All Studies
//                               </Typography>
//                             }
//                           />

//                           <Box
//                             sx={{
//                               flex: 1,
//                               minHeight: 0,
//                               maxHeight: 280,
//                               overflowY: "auto",
//                               border: "1px solid #eee",
//                               borderRadius: 1,
//                             }}
//                           >
//                             {filteredStudies.length === 0 ? (
//                               <Typography
//                                 variant="body2"
//                                 color="text.secondary"
//                                 sx={{ p: 2, fontStyle: "italic" }}
//                               >
//                                 No studies match your search.
//                               </Typography>
//                             ) : (
//                               <List dense disablePadding>
//                                 {filteredStudies.map((study) => {
//                                   const checked = selectedStudies.includes(
//                                     study.irbStudy
//                                   );
//                                   return (
//                                     <ListItem
//                                       key={study.irbStudy}
//                                       button
//                                       onClick={() =>
//                                         handleStudyToggle(study.irbStudy)
//                                       }
//                                       sx={{
//                                         borderBottom: "1px solid #f2f2f2",
//                                         backgroundColor: checked
//                                           ? "rgba(80, 0, 0, 0.05)"
//                                           : "transparent",
//                                         "&:hover": {
//                                           backgroundColor: "rgba(80, 0, 0, 0.08)",
//                                         },
//                                       }}
//                                     >
//                                       <ListItemIcon sx={{ minWidth: 40 }}>
//                                         <Checkbox
//                                           checked={checked}
//                                           onChange={() =>
//                                             handleStudyToggle(study.irbStudy)
//                                           }
//                                           onClick={(e) => e.stopPropagation()}
//                                           sx={{ color: maroon }}
//                                         />
//                                       </ListItemIcon>
//                                       <ListItemText primary={study.name} />
//                                     </ListItem>
//                                   );
//                                 })}
//                               </List>
//                             )}
//                           </Box>
//                         </>
//                       )}

//                       {hasStudySelected && (
//                         <Box sx={{ mt: 1.5, display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                           {allStudiesSelected ? (
//                             <Chip
//                               icon={<CheckCircleIcon sx={{ color: "white !important" }} />}
//                               label="Granted: All Studies"
//                               size="small"
//                               sx={{ backgroundColor: maroon, color: "white" }}
//                             />
//                           ) : (
//                             studies
//                               .filter((study) =>
//                                 selectedStudies.includes(study.irbStudy)
//                               )
//                               .map((study) => (
//                                 <Chip
//                                   key={study.irbStudy}
//                                   icon={<CheckCircleIcon sx={{ color: "white !important" }} />}
//                                   label={study.name}
//                                   size="small"
//                                   onDelete={() => handleStudyToggle(study.irbStudy)}
//                                   sx={{ backgroundColor: maroon, color: "white" }}
//                                 />
//                               ))
//                           )}
//                         </Box>
//                       )}
//                     </Box>
//                   </Paper>
//                 </Grid>

//                 {/* Module Permissions Panel */}
//                 <Grid item xs={12} md={6}>
//                   <Paper
//                     variant="outlined"
//                     sx={{
//                       borderRadius: 2,
//                       borderColor: "rgba(80, 0, 0, 0.25)",
//                       height: "100%",
//                       display: "flex",
//                       flexDirection: "column",
//                       opacity: hasStudySelected ? 1 : 0.6,
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 1,
//                         px: 2,
//                         py: 1.5,
//                         backgroundColor: "rgba(80, 0, 0, 0.06)",
//                         borderTopLeftRadius: 8,
//                         borderTopRightRadius: 8,
//                       }}
//                     >
//                       <ModuleIcon sx={{ color: maroon, fontSize: 22 }} />
//                       <Typography sx={{ fontWeight: 700, color: maroon }}>
//                         Module Permissions
//                       </Typography>
//                     </Box>

//                     <Box sx={{ p: 2, flex: 1, overflowY: "auto", maxHeight: 360 }}>
//                       <List disablePadding>
//                         {Object.entries(permissionStructure).map(
//                           ([sectionKey, sectionData]) => (
//                             <Box key={sectionKey} sx={{ mb: 0.5 }}>
//                               <ListItem
//                                 button
//                                 onClick={() => toggleSection(sectionKey)}
//                                 sx={{
//                                   backgroundColor: expandedSections[sectionKey]
//                                     ? "rgba(80, 0, 0, 0.1)"
//                                     : "transparent",
//                                   borderRadius: 1,
//                                 }}
//                               >
//                                 <ListItemIcon>
//                                   <Checkbox
//                                     checked={permissions[sectionKey] || false}
//                                     disabled={!hasStudySelected}
//                                     onChange={(e) =>
//                                       handlePermissionChange(
//                                         sectionKey,
//                                         e.target.checked
//                                       )
//                                     }
//                                     onClick={(e) => e.stopPropagation()}
//                                     sx={{ color: maroon }}
//                                   />
//                                 </ListItemIcon>
//                                 <ListItemText
//                                   primary={sectionData.label}
//                                   sx={{ fontWeight: 600 }}
//                                 />
//                                 {expandedSections[sectionKey] ? (
//                                   <ExpandLessIcon />
//                                 ) : (
//                                   <ExpandMoreIcon />
//                                 )}
//                               </ListItem>

//                               {expandedSections[sectionKey] && (
//                                 <List component="div" disablePadding>
//                                   {sectionData.permissions.map((permission) => (
//                                     <ListItem key={permission} sx={{ pl: 6 }}>
//                                       <ListItemIcon>
//                                         <Checkbox
//                                           checked={
//                                             hasStudySelected &&
//                                             (permissions[sectionKey] || false)
//                                           }
//                                           disabled
//                                           sx={{ color: maroon }}
//                                         />
//                                       </ListItemIcon>
//                                       <ListItemText primary={permission} />
//                                     </ListItem>
//                                   ))}
//                                 </List>
//                               )}
//                             </Box>
//                           )
//                         )}
//                       </List>
//                     </Box>
//                   </Paper>
//                 </Grid>
//               </Grid>
//             )}
//           </>
//         )}
//       </DialogContent>

//       <DialogActions sx={{ p: 3, gap: 1 }}>
//         <Button
//           onClick={handleClose}
//           variant="outlined"
//           sx={{
//             borderColor: "#8B4513",
//             color: "#8B4513",
//             textTransform: "none",
//             "&:hover": {
//               borderColor: "#8B4513",
//               backgroundColor: "rgba(139, 69, 19, 0.1)",
//             },
//           }}
//         >
//           CANCEL
//         </Button>
//         <Button
//           onClick={handleSave}
//           variant="contained"
//           disabled={
//             !selectedRole ||
//             loading ||
//             (Object.values(permissions).some(Boolean) && !hasStudySelected)
//           }
//           sx={{
//             backgroundColor: maroon,
//             color: "white",
//             textTransform: "none",
//             "&:hover": {
//               backgroundColor: "#4a0000",
//             },
//             "&:disabled": {
//               backgroundColor: "#ccc",
//               color: "#666",
//             },
//           }}
//         >
//           {loading ? (
//             <CircularProgress size={20} sx={{ color: "white" }} />
//           ) : (
//             "SAVE CHANGES"
//           )}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default EditUserPermissionsModal;
// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Box,
//   Typography,
//   Checkbox,
//   FormControlLabel,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   IconButton,
//   Alert,
//   Divider,
//   CircularProgress,
// } from "@mui/material";
// import {
//   Close as CloseIcon,
//   ExpandLess as ExpandLessIcon,
//   ExpandMore as ExpandMoreIcon,
// } from "@mui/icons-material";
// import {
//   getUserPermissionsByUserId,
//   updateUserPermissions,
//   fetchActiveStudies,
// } from "../utils/api";

// const maroon = "#500000";

// const EditUserPermissionsModal = ({ open, onClose, onSave, user }) => {
//   const [selectedRole, setSelectedRole] = useState("");
//   const [permissions, setPermissions] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [userPermissions, setUserPermissions] = useState([]);
//   const [studies, setStudies] = useState([]);
//   const [studiesLoading, setStudiesLoading] = useState(false);
//   const [selectedStudies, setSelectedStudies] = useState([]);
//   const [expandedSections, setExpandedSections] = useState({
//     admin: true,
//     biobank: true,
//     researcher: true,
//   });

//   const roleOptions = [
//     "Super Admin",
//     "System Manager",
//     "BioBank Coordinator",
//     "Clinic Coordinator",
//     "Sample Technician",
//     "Regulatory Admin",
//     "Viewer",
//   ];

//   const roleDescriptions = {
//     "Super Admin":
//       "Full system authority. This includes unrestricted access to every functions in the Admin, BioBank and Researcher modules.",
//     "System Manager":
//       "Responsible for platform setup and governance. Can configure users, manage data visibility, and oversee auditing activities, but cannot enact any regulatory concerns.",
//     "BioBank Coordinator":
//       "Oversees BioBank operational activities. Manages kits, scheduling, and supervision sample logistics, but does not handle patient health records or regulatory actions.",
//     "Clinic Coordinator":
//       "Handles day-to-day workflows, focused on patient scheduling, intake, and collection of samples during visits.",
//     "Sample Technician":
//       "Focused solely on laboratory workflows. Processes collected samples into aliquots and manages check-ins/out for shipments.",
//     "Regulatory Admin":
//       "Read-only access for compliance and regulatory oversight. Provides oversight of consent, patient traceability, and sample lifecycle data.",
//     Viewer:
//       "Read-only access for operational oversight. Provides visibility into patient scheduling, patient flow, and sample collection, without rights to enact changes or visibility.",
//   };

//   const permissionStructure = {
//     admin: {
//       label: "Admin",
//       permissions: [
//         "Task Management",
//         "User Management",
//         "Sample Data",
//         "Participant Data",
//         "Program Directory",
//       ],
//     },
//     biobank: {
//       label: "BioBank",
//       permissions: [
//         "Participant Scheduling",
//         "Collection Kits",
//         "Participant Check-in",
//         "Sample Collection",
//         "Sample Processing",
//         "Aliquot Management",
//       ],
//     },
//     researcher: {
//       label: "Researcher",
//       permissions: ["Data Access", "Data Export"],
//     },
//   };

//   // Predefined role permissions
//   const rolePermissions = useMemo(
//     () => ({
//       "Super Admin": {
//         admin: true,
//         biobank: true,
//         researcher: true,
//       },
//       "System Manager": {
//         admin: true,
//         biobank: true,
//         researcher: false,
//       },
//       "BioBank Coordinator": {
//         admin: false,
//         biobank: true,
//         researcher: false,
//       },
//       "Clinic Coordinator": {
//         admin: false,
//         biobank: true,
//         researcher: false,
//       },
//       "Sample Technician": {
//         admin: false,
//         biobank: true,
//         researcher: false,
//       },
//       "Regulatory Admin": {
//         admin: true,
//         biobank: false,
//         researcher: false,
//       },
//       Viewer: {
//         admin: true,
//         biobank: true,
//         researcher: false,
//       },
//     }),
//     []
//   );

//   const loadUserPermissions = useCallback(async () => {
//     if (!user?.userId) return;

//     try {
//       setLoading(true);
//       const permissions = await getUserPermissionsByUserId(user.userId);
//       setUserPermissions(permissions);

//       const existingStudyPermissions = (permissions || [])
//         .filter((permission) => permission.module?.toLowerCase() === "study")
//         .map((permission) => permission.permission);
//       setSelectedStudies(existingStudyPermissions);

//       // Initialize permissions based on user's current role
//       const userRole =
//         Array.isArray(user.userRoles) && user.userRoles.length > 0
//           ? user.userRoles[0]
//           : user.userRole || "";
//       const currentPermissions = rolePermissions[userRole] || {};
//       setPermissions(currentPermissions);

//       // If user has existing permissions, load them
//       if (permissions && permissions.length > 0) {
//         const existingPermissions = {};

//         permissions.forEach((permission) => {
//           if (permission.module) {
//             existingPermissions[permission.module.toLowerCase()] = true;
//           }
//         });

//         setPermissions(existingPermissions);
//       }
//     } catch (err) {
//       console.error("Error loading user permissions:", err);
//       setError("Failed to load user permissions");
//     } finally {
//       setLoading(false);
//     }
//   }, [user?.userId, user?.userRole, user?.userRoles, rolePermissions]);

//   useEffect(() => {
//     const loadStudies = async () => {
//       try {
//         setStudiesLoading(true);
//         const activeStudies = await fetchActiveStudies();
//         setStudies(activeStudies);
//       } catch (err) {
//         console.error("Error loading studies:", err);
//         setStudies([]);
//       } finally {
//         setStudiesLoading(false);
//       }
//     };

//     if (open) {
//       loadStudies();
//     }
//   }, [open]);

//   useEffect(() => {
//     if (open && user) {
//       // Handle both single userRole and array userRoles
//       const userRole =
//         Array.isArray(user.userRoles) && user.userRoles.length > 0
//           ? user.userRoles[0]
//           : user.userRole || "";
//       setSelectedRole(userRole);
//       setError(null);
//       loadUserPermissions();
//     }
//   }, [open, user, loadUserPermissions]);

//   const handleRoleChange = (event) => {
//     const role = event.target.value;
//     setSelectedRole(role);

//     // Update permissions based on selected role
//     const rolePerms = rolePermissions[role] || {};
//     setPermissions(rolePerms);
//   };

//   const handlePermissionChange = (section, checked) => {
//     // Roles are predefined — only section-level changes are allowed.
//     setPermissions((prev) => ({
//       ...prev,
//       [section]: checked,
//     }));
//   };

//   const handleStudyToggle = (irbStudy) => {
//     setSelectedStudies((prev) =>
//       prev.includes(irbStudy)
//         ? prev.filter((s) => s !== irbStudy)
//         : [...prev, irbStudy]
//     );
//   };

//   const handleAllStudiesToggle = (checked) => {
//     if (checked) {
//       setSelectedStudies(studies.map((study) => study.irbStudy));
//     } else {
//       setSelectedStudies([]);
//     }
//   };

//   const allStudiesSelected =
//     studies.length > 0 && selectedStudies.length === studies.length;

//   const toggleSection = (section) => {
//     setExpandedSections((prev) => ({
//       ...prev,
//       [section]: !prev[section],
//     }));
//   };

//   const handleSave = async () => {
//     try {
//       setLoading(true);

//       // Prepare permissions data for bulk update
//       const permissionsToUpdate = [];

//       Object.entries(permissions).forEach(([module, enabled]) => {
//         if (enabled) {
//           // Include all permissions for the module
//           const modulePermissions =
//             permissionStructure[module]?.permissions || [];
//           modulePermissions.forEach((permission) => {
//             permissionsToUpdate.push({
//               module: module.charAt(0).toUpperCase() + module.slice(1), // Capitalize first letter
//               permission: permission,
//             });
//           });
//         }
//       });

//       selectedStudies.forEach((irbStudy) => {
//         permissionsToUpdate.push({
//           module: "Study",
//           permission: irbStudy,
//         });
//       });

//       // Prepare the bulk update request
//       const updateRequest = {
//         userId: user.userId,
//         userRoles: [selectedRole], // Add the selected role to userRoles array
//         permissions: permissionsToUpdate,
//       };

//       // Update permissions using bulk update endpoint
//       await updateUserPermissions(updateRequest);

//       // Call the onSave callback with the updated data
//       onSave({
//         userRole: selectedRole,
//         userRoles: [selectedRole],
//         permissions: permissions,
//         studies: selectedStudies,
//       });

//       onClose();
//     } catch (err) {
//       console.error("Error updating permissions:", err);
//       setError("Failed to update permissions");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClose = () => {
//     setSelectedRole("");
//     setPermissions({});
//     setLoading(false);
//     setError(null);
//     setUserPermissions([]);
//     setSelectedStudies([]);
//     onClose();
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={handleClose}
//       maxWidth="md"
//       fullWidth
//       PaperProps={{
//         sx: {
//           borderRadius: 2,
//           boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
//         },
//       }}
//     >
//       <DialogTitle
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           pb: 2,
//         }}
//       >
//         <Typography variant="h6" sx={{ fontWeight: 600, color: maroon }}>
//           Edit User Permissions
//         </Typography>
//         <IconButton onClick={handleClose} size="small">
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>

//       <DialogContent sx={{ p: 3 }}>
//         {loading && (
//           <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//             <CircularProgress sx={{ color: maroon }} />
//           </Box>
//         )}

//         {error && (
//           <Alert severity="error" sx={{ mb: 3 }}>
//             {error}
//           </Alert>
//         )}

//         {!loading && !error && (
//           <>
//             {/* Role Selection */}
//             <FormControl fullWidth sx={{ mb: 3 }}>
//               <InputLabel>User Role</InputLabel>
//               <Select
//                 value={selectedRole}
//                 onChange={handleRoleChange}
//                 label="User Role"
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     "&:hover fieldset": {
//                       borderColor: maroon,
//                     },
//                     "&.Mui-focused fieldset": {
//                       borderColor: maroon,
//                     },
//                   },
//                 }}
//               >
//                 {roleOptions.map((role) => (
//                   <MenuItem key={role} value={role}>
//                     {role}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             {/* Tooltip */}
//             {selectedRole && (
//               <Alert
//                 severity="info"
//                 sx={{
//                   mb: 3,
//                   backgroundColor: maroon,
//                   color: "white",
//                   "& .MuiAlert-icon": {
//                     color: "white",
//                   },
//                 }}
//               >
//                 Permissions are pre-determined for this role.
//               </Alert>
//             )}

//             {/* User Role Overview */}
//             {selectedRole && (
//               <Box sx={{ mb: 3 }}>
//                 <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
//                   User Role Overview
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   {roleDescriptions[selectedRole]}
//                 </Typography>
//               </Box>
//             )}

//             {/* Data Permissions List */}
//             {selectedRole && (
//               <Box sx={{ mb: 3 }}>
//                 <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2 }}>
//                   Data Permissions
//                 </Typography>

//                 {studiesLoading ? (
//                   <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
//                     <CircularProgress size={24} sx={{ color: maroon }} />
//                   </Box>
//                 ) : (
//                   <List>
//                     <ListItem
//                       sx={{
//                         backgroundColor: "rgba(80, 0, 0, 0.1)",
//                         borderRadius: 1,
//                         mb: 0.5,
//                       }}
//                     >
//                       <ListItemIcon>
//                         <Checkbox
//                           checked={allStudiesSelected}
//                           onChange={(e) =>
//                             handleAllStudiesToggle(e.target.checked)
//                           }
//                           sx={{ color: maroon }}
//                         />
//                       </ListItemIcon>
//                       <ListItemText
//                         primary="All Studies"
//                         sx={{ fontWeight: 600 }}
//                       />
//                     </ListItem>

//                     {studies.map((study) => (
//                       <ListItem key={study.irbStudy} sx={{ pl: 6 }}>
//                         <ListItemIcon>
//                           <Checkbox
//                             checked={selectedStudies.includes(study.irbStudy)}
//                             onChange={() => handleStudyToggle(study.irbStudy)}
//                             sx={{ color: maroon }}
//                           />
//                         </ListItemIcon>
//                         <ListItemText primary={study.name} />
//                       </ListItem>
//                     ))}
//                   </List>
//                 )}
//               </Box>
//             )}

//             {/* Permissions List */}
//             {selectedRole && (
//               <Box>
//                 <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2 }}>
//                   Module Permissions
//                 </Typography>

//                 <List>
//                   {Object.entries(permissionStructure).map(
//                     ([sectionKey, sectionData]) => (
//                       <Box key={sectionKey}>
//                         <ListItem
//                           button
//                           onClick={() => toggleSection(sectionKey)}
//                           sx={{
//                             backgroundColor: expandedSections[sectionKey]
//                               ? "rgba(80, 0, 0, 0.1)"
//                               : "transparent",
//                             borderRadius: 1,
//                             mb: 0.5,
//                           }}
//                         >
//                           <ListItemIcon>
//                             <Checkbox
//                               checked={permissions[sectionKey] || false}
//                               onChange={(e) =>
//                                 handlePermissionChange(
//                                   sectionKey,
//                                   e.target.checked
//                                 )
//                               }
//                               sx={{ color: maroon }}
//                             />
//                           </ListItemIcon>
//                           <ListItemText
//                             primary={sectionData.label}
//                             sx={{ fontWeight: 600 }}
//                           />
//                           {expandedSections[sectionKey] ? (
//                             <ExpandLessIcon />
//                           ) : (
//                             <ExpandMoreIcon />
//                           )}
//                         </ListItem>

//                         {expandedSections[sectionKey] && (
//                           <List component="div" disablePadding>
//                             {sectionData.permissions.map((permission) => (
//                               <ListItem key={permission} sx={{ pl: 6 }}>
//                                 <ListItemIcon>
//                                   <Checkbox
//                                     checked={permissions[sectionKey] || false}
//                                     disabled
//                                     sx={{ color: maroon }}
//                                   />
//                                 </ListItemIcon>
//                                 <ListItemText primary={permission} />
//                               </ListItem>
//                             ))}
//                           </List>
//                         )}
//                       </Box>
//                     )
//                   )}
//                 </List>
//               </Box>
//             )}
//           </>
//         )}
//       </DialogContent>

//       <DialogActions sx={{ p: 3, gap: 1 }}>
//         <Button
//           onClick={handleClose}
//           variant="outlined"
//           sx={{
//             borderColor: "#8B4513",
//             color: "#8B4513",
//             textTransform: "none",
//             "&:hover": {
//               borderColor: "#8B4513",
//               backgroundColor: "rgba(139, 69, 19, 0.1)",
//             },
//           }}
//         >
//           CANCEL
//         </Button>
//         <Button
//           onClick={handleSave}
//           variant="contained"
//           disabled={!selectedRole || loading}
//           sx={{
//             backgroundColor: maroon,
//             color: "white",
//             textTransform: "none",
//             "&:hover": {
//               backgroundColor: "#4a0000",
//             },
//             "&:disabled": {
//               backgroundColor: "#ccc",
//               color: "#666",
//             },
//           }}
//         >
//           {loading ? (
//             <CircularProgress size={20} sx={{ color: "white" }} />
//           ) : (
//             "SAVE CHANGES"
//           )}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default EditUserPermissionsModal;

import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Alert,
  Divider,
  CircularProgress,
  Chip,
  Grid,
  Paper,
  TextField,
  InputAdornment,
} from "@mui/material";
import {
  Close as CloseIcon,
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  Search as SearchIcon,
  ScienceOutlined as StudyIcon,
  ViewModuleOutlined as ModuleIcon,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";
import {
  getUserPermissionsByUserId,
  updateUserPermissions,
  fetchActiveStudies,
} from "../utils/api";

const maroon = "#500000";

const EditUserPermissionsModal = ({ open, onClose, onSave, user }) => {
  const [selectedRole, setSelectedRole] = useState("");
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userPermissions, setUserPermissions] = useState([]);
  const [studies, setStudies] = useState([]);
  const [studiesLoading, setStudiesLoading] = useState(false);
  const [selectedStudies, setSelectedStudies] = useState([]);
  const [studySearchTerm, setStudySearchTerm] = useState("");
  const [expandedSections, setExpandedSections] = useState({
    admin: true,
    biobank: true,
    researcher: true,
  });

  const roleLabels = {
    "System Manager": "Study Manager",
  };

  const roleOptions = [
    "Super Admin",
    "System Manager",
    "BioBank Coordinator",
    "Clinic Coordinator",
    "Sample Technician",
    "Regulatory Admin",
    "Viewer",
  ];

  const roleDescriptions = {
    "Super Admin":
      "Full system authority. This includes unrestricted access to every functions in the Admin, BioBank and Researcher modules.",
    "System Manager":
      "Responsible for platform setup and governance. Can configure users, manage data visibility, and oversee auditing activities, but cannot enact any regulatory concerns.",
    "BioBank Coordinator":
      "Oversees BioBank operational activities. Manages kits, scheduling, and supervision sample logistics, but does not handle patient health records or regulatory actions.",
    "Clinic Coordinator":
      "Handles day-to-day workflows, focused on patient scheduling, intake, and collection of samples during visits.",
    "Sample Technician":
      "Focused solely on laboratory workflows. Processes collected samples into aliquots and manages check-ins/out for shipments.",
    "Regulatory Admin":
      "Read-only access for compliance and regulatory oversight. Provides oversight of consent, patient traceability, and sample lifecycle data.",
    Viewer:
      "Read-only access for operational oversight. Provides visibility into patient scheduling, patient flow, and sample collection, without rights to enact changes or visibility.",
  };

  const permissionStructure = {
    admin: {
      label: "Admin",
      permissions: [
        "Task Management",
        "User Management",
        "Sample Data",
        "Participant Data",
        "Program Directory",
      ],
    },
    biobank: {
      label: "BioBank",
      permissions: [
        "Participant Scheduling",
        "Collection Kits",
        "Participant Check-in",
        "Sample Collection",
        "Sample Processing",
        "Aliquot Management",
      ],
    },
    researcher: {
      label: "Researcher",
      permissions: ["Data Access", "Data Export"],
    },
  };

  // Predefined role permissions
  const rolePermissions = useMemo(
    () => ({
      "Super Admin": {
        admin: true,
        biobank: true,
        researcher: true,
      },
      "System Manager": {
        admin: true,
        biobank: true,
        researcher: false,
      },
      "BioBank Coordinator": {
        admin: false,
        biobank: true,
        researcher: false,
      },
      "Clinic Coordinator": {
        admin: false,
        biobank: true,
        researcher: false,
      },
      "Sample Technician": {
        admin: false,
        biobank: true,
        researcher: false,
      },
      "Regulatory Admin": {
        admin: true,
        biobank: false,
        researcher: false,
      },
      Viewer: {
        admin: true,
        biobank: true,
        researcher: false,
      },
    }),
    []
  );

  const loadUserPermissions = useCallback(async () => {
    if (!user?.userId) return;

    try {
      setLoading(true);
      const permissions = await getUserPermissionsByUserId(user.userId);
      setUserPermissions(permissions);

      const existingStudyPermissions = (permissions || [])
        .filter((permission) => permission.module?.toLowerCase() === "study")
        .map((permission) => permission.permission);
      setSelectedStudies(existingStudyPermissions);

      // Initialize permissions based on user's current role
      const userRole =
        Array.isArray(user.userRoles) && user.userRoles.length > 0
          ? user.userRoles[0]
          : user.userRole || "";
      const currentPermissions = rolePermissions[userRole] || {};
      setPermissions(currentPermissions);

      // If user has existing permissions, load them
      if (permissions && permissions.length > 0) {
        const existingPermissions = {};

        permissions.forEach((permission) => {
          if (permission.module) {
            existingPermissions[permission.module.toLowerCase()] = true;
          }
        });

        setPermissions(existingPermissions);
      }
    } catch (err) {
      console.error("Error loading user permissions:", err);
      setError("Failed to load user permissions");
    } finally {
      setLoading(false);
    }
  }, [user?.userId, user?.userRole, user?.userRoles, rolePermissions]);

  useEffect(() => {
    const loadStudies = async () => {
      try {
        setStudiesLoading(true);
        const activeStudies = await fetchActiveStudies();
        setStudies(activeStudies);
      } catch (err) {
        console.error("Error loading studies:", err);
        setStudies([]);
      } finally {
        setStudiesLoading(false);
      }
    };

    if (open) {
      loadStudies();
    }
  }, [open]);

  useEffect(() => {
    if (open && user) {
      // Handle both single userRole and array userRoles
      const userRole =
        Array.isArray(user.userRoles) && user.userRoles.length > 0
          ? user.userRoles[0]
          : user.userRole || "";
      setSelectedRole(userRole);
      setError(null);
      loadUserPermissions();
    }
  }, [open, user, loadUserPermissions]);

  const handleRoleChange = (event) => {
    const role = event.target.value;
    setSelectedRole(role);

    // Update permissions based on selected role
    const rolePerms = rolePermissions[role] || {};
    setPermissions(rolePerms);
  };

  const handlePermissionChange = (section, checked) => {
    // Roles are predefined — only section-level changes are allowed.
    setPermissions((prev) => ({
      ...prev,
      [section]: checked,
    }));
  };

  const handleStudyToggle = (irbStudy) => {
    setSelectedStudies((prev) =>
      prev.includes(irbStudy)
        ? prev.filter((s) => s !== irbStudy)
        : [...prev, irbStudy]
    );
  };

  const handleAllStudiesToggle = (checked) => {
    if (checked) {
      setSelectedStudies(studies.map((study) => study.irbStudy));
    } else {
      setSelectedStudies([]);
    }
  };

  const allStudiesSelected =
    studies.length > 0 && selectedStudies.length === studies.length;

  const hasStudySelected = selectedStudies.length > 0;

  const filteredStudies = studies.filter((study) =>
    study.name.toLowerCase().includes(studySearchTerm.toLowerCase())
  );

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const handleSave = async () => {
    try {
      setLoading(true);

      // Prepare permissions data for bulk update
      const permissionsToUpdate = [];

      Object.entries(permissions).forEach(([module, enabled]) => {
        if (enabled && hasStudySelected) {
          // Include all permissions for the module
          const modulePermissions =
            permissionStructure[module]?.permissions || [];
          modulePermissions.forEach((permission) => {
            permissionsToUpdate.push({
              module: module.charAt(0).toUpperCase() + module.slice(1), // Capitalize first letter
              permission: permission,
            });
          });
        }
      });

      selectedStudies.forEach((irbStudy) => {
        permissionsToUpdate.push({
          module: "Study",
          permission: irbStudy,
        });
      });

      // Prepare the bulk update request
      const updateRequest = {
        userId: user.userId,
        userRoles: [selectedRole], // Add the selected role to userRoles array
        permissions: permissionsToUpdate,
      };

      // Update permissions using bulk update endpoint
      await updateUserPermissions(updateRequest);

      // Call the onSave callback with the updated data
      onSave({
        userRole: selectedRole,
        userRoles: [selectedRole],
        permissions: permissions,
        studies: selectedStudies,
      });

      onClose();
    } catch (err) {
      console.error("Error updating permissions:", err);
      setError("Failed to update permissions");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setSelectedRole("");
    setPermissions({});
    setLoading(false);
    setError(null);
    setUserPermissions([]);
    setSelectedStudies([]);
    setStudySearchTerm("");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 2,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, color: maroon }}>
          Edit Module &amp; Study Permissions
        </Typography>
        <IconButton onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        {loading && (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress sx={{ color: maroon }} />
          </Box>
        )}

        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        {!loading && !error && (
          <>
            {/* Role Selection */}
            <FormControl fullWidth sx={{ mb: 3 }}>
              <InputLabel>User Role</InputLabel>
              <Select
                value={selectedRole}
                onChange={handleRoleChange}
                label="User Role"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": {
                      borderColor: maroon,
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: maroon,
                    },
                  },
                }}
              >
                {roleOptions.map((role) => (
                  <MenuItem key={role} value={role}>
                    {roleLabels[role] || role}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Tooltip */}
            {selectedRole && (
              <Alert
                severity="info"
                sx={{
                  mb: 3,
                  backgroundColor: maroon,
                  color: "white",
                  "& .MuiAlert-icon": {
                    color: "white",
                  },
                }}
              >
                Permissions are pre-determined for this role.
              </Alert>
            )}

            {/* User Role Overview */}
            {selectedRole && (
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                  User Role Overview
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {roleDescriptions[selectedRole]}
                </Typography>
              </Box>
            )}

            {!hasStudySelected && selectedRole && (
              <Alert severity="warning" sx={{ mb: 2 }}>
                Select at least one study to grant module permissions for that study.
              </Alert>
            )}

            {/* Module Permissions + Study Permissions, shown side by side */}
            {selectedRole && (
              <Grid container spacing={2.5}>
                {/* Study Permissions Panel */}
                <Grid item xs={12} md={6}>
                  <Paper
                    variant="outlined"
                    sx={{
                      borderRadius: 2,
                      borderColor: "rgba(80, 0, 0, 0.25)",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        px: 2,
                        py: 1.5,
                        backgroundColor: "rgba(80, 0, 0, 0.06)",
                        borderTopLeftRadius: 8,
                        borderTopRightRadius: 8,
                      }}
                    >
                      <StudyIcon sx={{ color: maroon, fontSize: 22 }} />
                      <Typography sx={{ fontWeight: 700, color: maroon }}>
                        Study Permissions
                      </Typography>
                      {hasStudySelected && (
                        <Chip
                          size="small"
                          label={
                            allStudiesSelected
                              ? "All Studies"
                              : `${selectedStudies.length} selected`
                          }
                          sx={{
                            ml: "auto",
                            backgroundColor: maroon,
                            color: "white",
                            fontWeight: 600,
                          }}
                        />
                      )}
                    </Box>

                    <Box sx={{ p: 2, display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
                      <TextField
                        placeholder="Search studies..."
                        size="small"
                        fullWidth
                        value={studySearchTerm}
                        onChange={(e) => setStudySearchTerm(e.target.value)}
                        sx={{
                          mb: 1.5,
                          "& .MuiOutlinedInput-root": {
                            "&:hover fieldset": { borderColor: maroon },
                            "&.Mui-focused fieldset": { borderColor: maroon },
                          },
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon sx={{ fontSize: 20, color: "text.secondary" }} />
                            </InputAdornment>
                          ),
                        }}
                      />

                      {studiesLoading ? (
                        <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                          <CircularProgress size={24} sx={{ color: maroon }} />
                        </Box>
                      ) : (
                        <>
                          <FormControlLabel
                            sx={{
                              mx: 0,
                              mb: 0.5,
                              px: 1,
                              py: 0.5,
                              borderRadius: 1,
                              backgroundColor: "rgba(80, 0, 0, 0.08)",
                            }}
                            control={
                              <Checkbox
                                checked={allStudiesSelected}
                                indeterminate={
                                  hasStudySelected && !allStudiesSelected
                                }
                                onChange={(e) =>
                                  handleAllStudiesToggle(e.target.checked)
                                }
                                sx={{ color: maroon }}
                              />
                            }
                            label={
                              <Typography sx={{ fontWeight: 600 }}>
                                All Studies
                              </Typography>
                            }
                          />

                          <Box
                            sx={{
                              flex: 1,
                              minHeight: 0,
                              maxHeight: 280,
                              overflowY: "auto",
                              border: "1px solid #eee",
                              borderRadius: 1,
                            }}
                          >
                            {filteredStudies.length === 0 ? (
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{ p: 2, fontStyle: "italic" }}
                              >
                                No studies match your search.
                              </Typography>
                            ) : (
                              <List dense disablePadding>
                                {filteredStudies.map((study) => {
                                  const checked = selectedStudies.includes(
                                    study.irbStudy
                                  );
                                  return (
                                    <ListItem
                                      key={study.irbStudy}
                                      button
                                      onClick={() =>
                                        handleStudyToggle(study.irbStudy)
                                      }
                                      sx={{
                                        borderBottom: "1px solid #f2f2f2",
                                        backgroundColor: checked
                                          ? "rgba(80, 0, 0, 0.05)"
                                          : "transparent",
                                        "&:hover": {
                                          backgroundColor: "rgba(80, 0, 0, 0.08)",
                                        },
                                      }}
                                    >
                                      <ListItemIcon sx={{ minWidth: 40 }}>
                                        <Checkbox
                                          checked={checked}
                                          onChange={() =>
                                            handleStudyToggle(study.irbStudy)
                                          }
                                          onClick={(e) => e.stopPropagation()}
                                          sx={{ color: maroon }}
                                        />
                                      </ListItemIcon>
                                      <ListItemText primary={study.name} />
                                    </ListItem>
                                  );
                                })}
                              </List>
                            )}
                          </Box>
                        </>
                      )}

                      {hasStudySelected && (
                        <Box sx={{ mt: 1.5, display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                          {allStudiesSelected ? (
                            <Chip
                              icon={<CheckCircleIcon sx={{ color: "white !important" }} />}
                              label="Granted: All Studies"
                              size="small"
                              sx={{ backgroundColor: maroon, color: "white" }}
                            />
                          ) : (
                            studies
                              .filter((study) =>
                                selectedStudies.includes(study.irbStudy)
                              )
                              .map((study) => (
                                <Chip
                                  key={study.irbStudy}
                                  icon={<CheckCircleIcon sx={{ color: "white !important" }} />}
                                  label={study.name}
                                  size="small"
                                  onDelete={() => handleStudyToggle(study.irbStudy)}
                                  sx={{ backgroundColor: maroon, color: "white" }}
                                />
                              ))
                          )}
                        </Box>
                      )}
                    </Box>
                  </Paper>
                </Grid>

                {/* Module Permissions Panel */}
                <Grid item xs={12} md={6}>
                  <Paper
                    variant="outlined"
                    sx={{
                      borderRadius: 2,
                      borderColor: "rgba(80, 0, 0, 0.25)",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      opacity: hasStudySelected ? 1 : 0.6,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        px: 2,
                        py: 1.5,
                        backgroundColor: "rgba(80, 0, 0, 0.06)",
                        borderTopLeftRadius: 8,
                        borderTopRightRadius: 8,
                      }}
                    >
                      <ModuleIcon sx={{ color: maroon, fontSize: 22 }} />
                      <Typography sx={{ fontWeight: 700, color: maroon }}>
                        Module Permissions
                      </Typography>
                    </Box>

                    <Box sx={{ p: 2, flex: 1, overflowY: "auto", maxHeight: 360 }}>
                      <List disablePadding>
                        {Object.entries(permissionStructure).map(
                          ([sectionKey, sectionData]) => (
                            <Box key={sectionKey} sx={{ mb: 0.5 }}>
                              <ListItem
                                button
                                onClick={() => toggleSection(sectionKey)}
                                sx={{
                                  backgroundColor: expandedSections[sectionKey]
                                    ? "rgba(80, 0, 0, 0.1)"
                                    : "transparent",
                                  borderRadius: 1,
                                }}
                              >
                                <ListItemIcon>
                                  <Checkbox
                                    checked={permissions[sectionKey] || false}
                                    disabled={!hasStudySelected}
                                    onChange={(e) =>
                                      handlePermissionChange(
                                        sectionKey,
                                        e.target.checked
                                      )
                                    }
                                    onClick={(e) => e.stopPropagation()}
                                    sx={{ color: maroon }}
                                  />
                                </ListItemIcon>
                                <ListItemText
                                  primary={sectionData.label}
                                  sx={{ fontWeight: 600 }}
                                />
                                {expandedSections[sectionKey] ? (
                                  <ExpandLessIcon />
                                ) : (
                                  <ExpandMoreIcon />
                                )}
                              </ListItem>

                              {expandedSections[sectionKey] && (
                                <List component="div" disablePadding>
                                  {sectionData.permissions.map((permission) => (
                                    <ListItem key={permission} sx={{ pl: 6 }}>
                                      <ListItemIcon>
                                        <Checkbox
                                          checked={
                                            hasStudySelected &&
                                            (permissions[sectionKey] || false)
                                          }
                                          disabled
                                          sx={{ color: maroon }}
                                        />
                                      </ListItemIcon>
                                      <ListItemText primary={permission} />
                                    </ListItem>
                                  ))}
                                </List>
                              )}
                            </Box>
                          )
                        )}
                      </List>
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            )}
          </>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 3, gap: 1 }}>
        <Button
          onClick={handleClose}
          variant="outlined"
          sx={{
            borderColor: "#8B4513",
            color: "#8B4513",
            textTransform: "none",
            "&:hover": {
              borderColor: "#8B4513",
              backgroundColor: "rgba(139, 69, 19, 0.1)",
            },
          }}
        >
          CANCEL
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          disabled={
            !selectedRole ||
            loading ||
            (Object.values(permissions).some(Boolean) && !hasStudySelected)
          }
          sx={{
            backgroundColor: maroon,
            color: "white",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#4a0000",
            },
            "&:disabled": {
              backgroundColor: "#ccc",
              color: "#666",
            },
          }}
        >
          {loading ? (
            <CircularProgress size={20} sx={{ color: "white" }} />
          ) : (
            "SAVE CHANGES"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditUserPermissionsModal;